export default {
    orders: {
        type: "Grid",
        icon: "book",
        tableName: "ORDER",
        dataFields: [
            "IS_CURATOR_BY_CLIENT_OR_PARTNER",
            "HAS_EMPTY_STATEMENT_INVOICE"
        ],
        excludeFields: [
            "HAS_EMPTY_STATEMENT_INVOICE",
            "ADDITIONAL_CONTROL_TYPE_NAME",
            {
                key: "COMPANY_PARTNER_NAME_SMALL",
                notModule: "Transline"
            },
            {
                key: "COMPANY_PARTNER_NAME",
                module: "Transline"
            }
        ]
    },
    orders_current: {
        type: "Grid",
        icon: "book",
        tableName: "ORDER",
        prepares: [
            "DateBeginColor",
            "ColorizeMinDateGtdClearExpected",
            "DateFillingColorField",
            "DateReleaseColorField",
            "ActualExpectedDateArrivalCbxColorField"
        ],
        dataFields: [
            "ACTUAL_DATE_ARRIVAL_CBX",
            "EXPECTED_DATE_ARRIVAL_CBX",
            "ACTUAL_DATE_COMING",
            "INVOICE_TOTALS_QUANTITY",
            "GTD_READY_IS_AVAILABLE_AND_NO_START_DATE",
            "GTD_REGISTRATION_IS_AVAILABLE_AND_NO_START_DATE",
            "MORE_THAN_ONE_ADDITIONAL_CONTROL_TYPE",
            "ID_FIRST_ADDITIONAL_CONTROL_TYPE",
            "ID_ADDITIONAL_CONTROL_TYPE",
            "IS_CURATOR_BY_CLIENT_OR_PARTNER",
            "HAS_EMPTY_STATEMENT_INVOICE",
            "OPERATION_FORWARD_UNITS_IDS",
            "EXPECTED_DATE_START",
            "ID_UNIT_CATEGORY"
        ],
        excludeFields: [
            {
                key: "USER_LOGIST_FULL_NAME",
                module: "Modforward"
            },
            {
                key: "USER_CURATOR_FULL_NAME",
                module: "Modforward"
            },
            {
                key: "USER_DECLARANT_FULL_NAME",
                notModule: "Modforward"
            },
            {
                key: "USER_CUSTOMS_CLEARANCE_MANAGER_FULL_NAME",
                notModule: "Modforward"
            },
            "HAS_EMPTY_STATEMENT_INVOICE",
            "ADDITIONAL_CONTROL_TYPE_NAME",
            {
                key: "CONTRACTS_FEA_ADDITION_DOC_NUMBER",
                notModule: "Eastex"
            },
            {
                key: "COMPANY_PARTNER_NAME_SMALL",
                notModule: "Transline"
            },
            {
                key: "COMPANY_PARTNER_NAME",
                module: "Transline"
            }
        ],
        tabsApi: "ORDER.current",
        sysFilter: {
            IS_CURRENT: {
                key: "ACTUAL_DATE_COMING",
                type: "composite",
                onlyNulls: true
            }
        },
        sysFilterForCount: true,
        plugins: [
            "DontRemoveOrderWithInvoices",
            "UpdateCrmRequestStatusOnTrashOrders",
            "CuratorByClientOrPartner",
            "FilterUnitCategoryPlugin",
            "SetSalesManagerByClient",
            {
                name: "FilterConsigneeAndConsignorPlugin",
                params: {
                    modules: ["Eastex"]
                }
            },
            {
                name: "DisableInlineEdit",
                params: [
                    {
                        modules: ["Stel", "Intrans"],
                        fields: ["MIN_DATE_GTD_CLEAR_EXPECTED"],
                        not: true // разблокирует для указанных модулей
                    }
                ]
            },
            "DisableEditAdditionalControlType",
            {
                name: "HideSeaKindOrderPlugin",
                params: {
                    modules: ["Voskhod"]
                }
            },
            "DisableInlineEditActualDateAccauntantComplete",
            {
                name: "DisableJobSolutionPlugin",
                params: {
                    modules: ["Maersk"]
                }
            },
            {
                name: "ChangeBizScopePlugin",
                params: {
                    modules: ["Maersk"]
                }
            },
            {
                name: "SetMonthAndYearWhenCreatingOrder",
                params: {
                    module: "Maersk"
                }
            },
            {
                name: "ValidateOrder",
                params: {
                    notModules: ["DelExpress", "EuroAsia"]
                }
            },
            {
                name: "ValidateActualDateLogistComplete",
                params: {
                    modules: ["Eastex"]
                }
            },
            {
                name: "YusenGhqActivityDisableInsert",
                params: {
                    modules: ["Yusen"]
                }
            },
            {
                name: "FilterContractsAdditionOrderPlugin",
                params: {
                    modules: ["Eastex"]
                }
            },
            "FilterListUserPlugin"
        ],
        toolbar: {
            byModule: {
                default: "manageAssistants",
                Yusen: "ordersYusen"
            }
        }
    },
    orders_archive: {
        type: "Grid",
        icon: "book",
        tableName: "ORDER",
        prepares: [
            "DateBeginColor",
            "DateFillingColorField",
            "DateReleaseColorField",
            "ActualExpectedDateArrivalCbxColorField"
        ],
        dataFields: [
            "ACTUAL_DATE_ARRIVAL_CBX",
            "EXPECTED_DATE_ARRIVAL_CBX",
            "INVOICE_TOTALS_QUANTITY",
            "MORE_THAN_ONE_ADDITIONAL_CONTROL_TYPE",
            "ID_FIRST_ADDITIONAL_CONTROL_TYPE",
            "ID_ADDITIONAL_CONTROL_TYPE",
            "IS_CURATOR_BY_CLIENT_OR_PARTNER",
            "HAS_EMPTY_STATEMENT_INVOICE",
            "OPERATION_FORWARD_UNITS_IDS",
            "EXPECTED_DATE_START"
        ],
        excludeFields: [
            {
                key: "USER_LOGIST_FULL_NAME",
                module: "Modforward"
            },
            {
                key: "USER_CURATOR_FULL_NAME",
                module: "Modforward"
            },
            {
                key: "USER_DECLARANT_FULL_NAME",
                notModule: "Modforward"
            },
            {
                key: "USER_CUSTOMS_CLEARANCE_MANAGER_FULL_NAME",
                notModule: "Modforward"
            },
            "HAS_EMPTY_STATEMENT_INVOICE",
            "ADDITIONAL_CONTROL_TYPE_NAME",
            {
                key: "CONTRACTS_FEA_ADDITION_DOC_NUMBER",
                notModule: "Eastex"
            },
            {
                key: "COMPANY_PARTNER_NAME_SMALL",
                notModule: "Transline"
            },
            {
                key: "COMPANY_PARTNER_NAME",
                module: "Transline"
            }
        ],
        tabsApi: "ORDER.archive",
        sysFilter: {
            IS_ARCHIVE: {
                key: "ACTUAL_DATE_COMING",
                type: "composite",
                withNulls: false
            }
        },
        sysFilterForCount: true,
        plugins: [
            "DontRemoveOrderWithInvoices",
            "UpdateCrmRequestStatusOnTrashOrders",
            "DisableEditAdditionalControlType",
            "DisableInlineEditIsArchive",
            "CuratorByClientOrPartner",
            "SetSalesManagerByClient",
            {
                name: "FilterConsigneeAndConsignorPlugin",
                params: {
                    modules: ["Eastex"]
                }
            },
            {
                name: "DisableInlineEdit",
                params: [
                    {
                        modules: ["Stel", "Intrans"],
                        fields: ["MIN_DATE_GTD_CLEAR_EXPECTED"],
                        not: true // разблокирует для указанных модулей
                    }
                ]
            },
            {
                name: "HideSeaKindOrderPlugin",
                params: {
                    modules: ["Voskhod"]
                }
            },
            "DisableInlineEditActualDateAccauntantComplete",
            {
                name: "DisableJobSolutionPlugin",
                params: {
                    modules: ["Maersk"]
                }
            },
            {
                name: "ChangeBizScopePlugin",
                params: {
                    modules: ["Maersk"]
                }
            },
            {
                name: "SetMonthAndYearWhenCreatingOrder",
                params: {
                    module: "Maersk"
                }
            },
            {
                name: "ValidateOrder",
                params: {
                    notModules: ["DelExpress", "EuroAsia"]
                }
            },
            {
                name: "ValidateActualDateLogistComplete",
                params: {
                    modules: ["Eastex"]
                }
            },
            {
                name: "FilterContractsAdditionOrderPlugin",
                params: {
                    modules: ["Eastex"]
                }
            },
            "FilterListUserPlugin"
        ],
        toolbar: {
            byModule: {
                default: false,
                Yusen: "ordersYusen"
            }
        }
    },
    orders_all: {
        type: "Grid",
        icon: "book",
        tableName: "ORDER",
        prepares: [
            "DateBeginColor",
            "ColorizeMinDateGtdClearExpected",
            "DateFillingColorField",
            "DateReleaseColorField",
            "ActualExpectedDateArrivalCbxColorField"
        ],
        dataFields: [
            "ACTUAL_DATE_ARRIVAL_CBX",
            "EXPECTED_DATE_ARRIVAL_CBX",
            "ACTUAL_DATE_COMING",
            "INVOICE_TOTALS_QUANTITY",
            "GTD_READY_IS_AVAILABLE_AND_NO_START_DATE",
            "GTD_REGISTRATION_IS_AVAILABLE_AND_NO_START_DATE",
            "MORE_THAN_ONE_ADDITIONAL_CONTROL_TYPE",
            "ID_FIRST_ADDITIONAL_CONTROL_TYPE",
            "ID_ADDITIONAL_CONTROL_TYPE",
            "IS_CURATOR_BY_CLIENT_OR_PARTNER",
            "HAS_EMPTY_STATEMENT_INVOICE",
            "OPERATION_FORWARD_UNITS_IDS",
            "EXPECTED_DATE_START",
            "ID_UNIT_CATEGORY"
        ],
        excludeFields: [
            {
                key: "USER_LOGIST_FULL_NAME",
                module: "Modforward"
            },
            {
                key: "USER_CURATOR_FULL_NAME",
                module: "Modforward"
            },
            {
                key: "USER_DECLARANT_FULL_NAME",
                notModule: "Modforward"
            },
            {
                key: "USER_CUSTOMS_CLEARANCE_MANAGER_FULL_NAME",
                notModule: "Modforward"
            },
            "HAS_EMPTY_STATEMENT_INVOICE",
            "ADDITIONAL_CONTROL_TYPE_NAME",
            {
                key: "CONTRACTS_FEA_ADDITION_DOC_NUMBER",
                notModule: "Eastex"
            },
            {
                key: "COMPANY_PARTNER_NAME_SMALL",
                notModule: "Transline"
            },
            {
                key: "COMPANY_PARTNER_NAME",
                module: "Transline"
            }
        ],
        tabsApi: "ORDER.all",
        plugins: [
            "DontRemoveOrderWithInvoices",
            "UpdateCrmRequestStatusOnTrashOrders",
            "DisableEditAdditionalControlType",
            "DisableInlineEditIsArchive",
            "FilterUnitCategoryPlugin",
            "UpdateCrmRequestStatusOnTrashOrders",
            "CuratorByClientOrPartner",
            "SetSalesManagerByClient",
            {
                name: "YusenGhqActivityDisableInsert",
                params: {
                    modules: ["Yusen"]
                }
            },
            {
                name: "FilterConsigneeAndConsignorPlugin",
                params: {
                    modules: ["Eastex"]
                }
            },
            {
                name: "DisableInlineEdit",
                params: [
                    {
                        modules: ["Stel", "Intrans"],
                        fields: ["MIN_DATE_GTD_CLEAR_EXPECTED"],
                        not: true // разблокирует для указанных модулей
                    }
                ]
            },
            {
                name: "HideSeaKindOrderPlugin",
                params: {
                    modules: ["Voskhod"]
                }
            },
            "DisableInlineEditActualDateAccauntantComplete",
            {
                name: "DisableJobSolutionPlugin",
                params: {
                    modules: ["Maersk"]
                }
            },
            {
                name: "ChangeBizScopePlugin",
                params: {
                    modules: ["Maersk"]
                }
            },
            {
                name: "SetMonthAndYearWhenCreatingOrder",
                params: {
                    module: "Maersk"
                }
            },
            {
                name: "ValidateOrder",
                params: {
                    notModules: ["DelExpress", "EuroAsia"]
                }
            },
            {
                name: "ValidateActualDateLogistComplete",
                params: {
                    modules: ["Eastex"]
                }
            },
            {
                name: "FilterContractsAdditionOrderPlugin",
                params: {
                    modules: ["Eastex"]
                }
            },
            "FilterListUserPlugin"
        ],
        toolbar: {
            byModule: {
                default: "manageAssistants",
                Yusen: "ordersYusen"
            }
        }
    },
    positions_in_orders_all: {
        type: "Grid",
        tableName: "LIST_ORDER_POSITIONS",
        sysFilter: {
            hasParent: {
                key: "ID_PARENT_PART_ORDER_POSITION",
                type: "composite",
                onlyNulls: true
            }
        },
        sysFilterForCount: true,
        access: {
            create: false
        }
    },
    moved_orders_positions: {
        type: "Grid",
        tableName: "LIST_ORDER_POSITIONS",
        fields: [
            "ID",
            "BRUTTO",
            "LIST_CURRENCY_NAME",
            "LIST_NAME_WEIGHT_NAME",
            "PACKING_UNIT_TYPE_NAME",
            "NETTO",
            "PART_NUMBER",
            "PRICE",
            "QUANTITY",
            "SUM_PRICE",
            "UNIT_NUMBER",
            "TRADEMARK",
            "DESCRIPTION_RUS",
            "MANUFACTURER",
            "MARK",
            "STRUCTURE",
            "MODEL",
            "BARCODE",
            "STYLE_LINE",
            "AGE",
            "SEX",
            "PRODUCT_TYPE",
            "PRODUCT_CATEGORY",
            "MATERIAL",
            "COLOR",
            "HUMAN_HEIGHT_CM",
            "SIZE",
            "ORDER_SYS_SERIAL_NUMBER",
            "UNIT_STATUS_TEXT",
            "GTD_STATUS",
            "SEA_ARRIVAL_OPERATION_POINT_EXPECTED_DATE",
            "STATUS_POINT_CURRENT_NAME",
            "STATUS_POINT_END_ACTUAL_DATE",
            "STATUS_POINT_END_EXPECTED_DATE",
            "STATUS_POINT_START_ACTUAL_DEPARTURE_DATE",
            "STATUS_POINT_START_EXPECTED_DATE",
            "STATUS_POINT_END_COUNTRY_NAME",
            "UNIT_STATUS_DATE_START",
            "STATUS_POINT_END_NAME",
            "STATUS_POINT_START_NAME",
            "STATUS_POINT_START_COUNTRY_NAME",
            "SEA_ARRIVAL_OPERATION_POINT_ACTUAL_DATE",
            "ORDER_POINT_GTD_NAME",
            "SEA_PORT_TERMINAL_POINT_ACTUAL_DATE",
            "SEA_ARRIVAL_OPERATION_POINT_WAREHOUSE_NAME",
            "CLASS_CONCAT_NAME",
            "DT_CREATE",
            "DT_UPDATE",
            "LIST_USER_NAME_CREATE",
            "LIST_USER_NAME_UPDATE",
            "TNVED_CODE",
            "RNB_INDEX",
            "PRICE_PER_KG",
            "POSITIONS_GROUP_SUB_TOTALS_LOG_SUM",
            "POSITIONS_GROUP_SUB_TOTALS_CUSTOMS_SUM",
            "POSITIONS_GROUP_SUB_TOTALS_OTHER_SUM",
            "POSITION_TOTAL_INCOME",
            "VAT_VALUE",
            "DUTY_VALUE",
            "REMAINS",
            {
                key: "CUSTOM_MODE_NAME",
                module: "Rusmarine"
            }
        ],
        sysFilter: {
            isMoveTable: {
                key: "IS_MOVE_TABLE",
                type: "equal",
                value: 1
            }
        },
        sysFilterForCount: true,
        access: {
            create: false,
            remove: false
        }
    },
    operation_unit: {
        icon: "cubes",
        type: "Grid",
        tableName: "OPERATION_UNIT",
        prepares: [
            "DetentionDemurrageColors",
            "ColorizeMinDateGtdClearExpected",
            "TimexColorDateReleaseTo",
            "TransLogixColorDateReleaseTo",
            "ColorizeDriverCellInUnit",
            "ColorizeGtdFillingMinutes"
        ],
        hideColumnsInFullMode: ["GTD_MAX_COND_DATE"],
        dataFields: [
            "ID_OWNER_UNIT",
            "ORDER_SYS_SERIAL_NUMBER",
            "UNIT_NUMBER",
            "ID_UNIT_CATEGORY",
            "CURRENT_SEA_DOC_ID",
            "CURRENT_SEA_DOC_NAME",
            "CURRENT_SEA_DOC_ID_VESSEL",
            "CURRENT_SEA_DOC_VESSEL_NAME",
            "CURRENT_SEA_DOC_VESSEL_MMSI",
            "CURRENT_SEA_DOC_VESSEL_MMSI_OR_UNKNOWN",
            "GTD_READY_IS_AVAILABLE_AND_NO_START_DATE",
            "GTD_REGISTRATION_IS_AVAILABLE_AND_NO_START_DATE",
            "MAX_GTD_DATE_CLEAR",
            "MAX_GTD_DATE_RELEASE_FOR_PROCURING",
            "MAX_GTD_DATE_CONDITIONAL_CLEAR",

            "DATES_FORWARD_PRESENT",
            "DATES_FORWARD_EXECUTE",
            "COLLECTING_ALL_INCOMING_INVOICES_DATE",
            "SENDING_ALL_OUTGOING_INVOICES_DATE",
            "IS_VISITED",
            "ID_ADDITIONAL_CONTROL_TYPE",
            "HAS_EXPED_BOOLEAN",
            "TRAIN_NUMBER",
            {
                modules: ["Canavara"],
                fields: ["PREPARATION_GTD_DATE_TASK"]
            }
        ],
        excludeFields: [
            "FIRST_AUTO_COMPANY_EXECUTOR_NAME",
            "FIRST_AUTO_CURRENCY_COST_BUY_CHARCODE",
            "FIRST_AUTO_CURRENCY_COST_SALE_CHARCODE",
            "FIRST_AUTO_COST_BUY_TOTAL",
            "FIRST_AUTO_COST_SALE_TOTAL",
            "FIRST_AUTO_VAT_TYPE_BUY_NAME",
            "FIRST_AUTO_VAT_TYPE_SALE_NAME",
            "FIRST_AUTO_VAT_BUY_NAME",
            "FIRST_AUTO_VAT_SALE_NAME",
            "FIRST_AUTO_TEMPORARY_STORAGE_NAME",
            "FIRST_AUTO_BORDER_CROSSING_NAME",
            "ID_UNIT",
            "COMPANY_CONSIGNEE_NAME",
            {
                key: "ORDER_COMPANY_PARTNER_NAME_SMALL",
                notModule: "Transline"
            },
            {
                key: "ORDER_COMPANY_PARTNER_NAME",
                module: "Transline"
            }
        ],
        plugins: [
            "ValidateUnitNumber",
            {
                name: "FormBy",
                params: {
                    OperationUnitForm: {
                        id: "ID",
                        table: "OPERATION_UNIT"
                    },
                    EDIEventsForm: {
                        columns: ["EDI_LAST_EVENT"],
                        id: "ID",
                        table: "OPERATION_UNIT"
                    },
                    TrainForm: {
                        columns: ["TRAIN_NUMBER"],
                        id: "ID_TRAIN",
                        table: "TRAIN"
                    }
                }
            },
            "DisableEditAdditionalControlTypeIfNoForward",
            "DisableInlineEditIsArchive",
            "DisableInlineEditRailwayPoints"
        ]
    },
    operation_unit_current: { //Грузы(текущие)
        type: "Grid",
        icon: "book",
        tableName: "OPERATION_UNIT",
        prepares: [
            "DetentionDemurrageColors",
            "ColorizeMinDateGtdClearExpected",
            "TimexColorDateReleaseTo",
            "TransLogixColorDateReleaseTo",
            "ColorizeDriverCellInUnit",
            "ColorizeGtdFillingMinutes"
        ],
        tabsApi: "OPERATION_UNIT.current",
        sysFilter: {
            IS_CURRENT: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        sysFilterForCount: true,
        hideColumnsInFullMode: ["GTD_MAX_COND_DATE"],
        dataFields: [
            "DOC_PART_DATE",
            "ID_OWNER_UNIT",
            "ORDER_SYS_SERIAL_NUMBER",
            "UNIT_NUMBER",
            "ID_UNIT_CATEGORY",
            "CURRENT_SEA_DOC_ID",
            "CURRENT_SEA_DOC_NAME",
            "CURRENT_SEA_DOC_ID_VESSEL",
            "CURRENT_SEA_DOC_VESSEL_NAME",
            "CURRENT_SEA_DOC_VESSEL_MMSI",
            "CURRENT_SEA_DOC_VESSEL_MMSI_OR_UNKNOWN",
            "GTD_READY_IS_AVAILABLE_AND_NO_START_DATE",
            "GTD_REGISTRATION_IS_AVAILABLE_AND_NO_START_DATE",
            "MAX_GTD_DATE_CLEAR",
            "MAX_GTD_DATE_RELEASE_FOR_PROCURING",
            "MAX_GTD_DATE_CONDITIONAL_CLEAR",

            "DATES_FORWARD_PRESENT",
            "DATES_FORWARD_EXECUTE",

            "ID_FITO_OPERATION_DOC",
            "ID_VETO_OPERATION_DOC",
            "ID_CUSTOMS_OPERATION_DOC",
            "ID_IDK_OPERATION_DOC",
            "ID_WEIGHTING_OPERATION_DOC",
            "ID_MAX_EXPED",
            "ID_MAX_SEA",
            "ID_SEA_PORT_TERMINAL_POINT",
            "ID_TRAIN",
            "ID_ADDITIONAL_CONTROL_TYPE",
            "HAS_EXPED_BOOLEAN",
            "IS_CONTRACT_TEU",
            {
                key: "CUSTOM_MODE_NAME",
                module: "Rusmarine"
            },
            "IS_VISITED",
            "TRAIN_NUMBER",
            {
                modules: ["Canavara"],
                fields: ["PREPARATION_GTD_DATE_TASK"]
            }
        ],
        excludeFields: [
            "FIRST_AUTO_COMPANY_EXECUTOR_NAME",
            "FIRST_AUTO_CURRENCY_COST_BUY_CHARCODE",
            "FIRST_AUTO_CURRENCY_COST_SALE_CHARCODE",
            "FIRST_AUTO_COST_BUY_TOTAL",
            "FIRST_AUTO_COST_SALE_TOTAL",
            "FIRST_AUTO_VAT_TYPE_BUY_NAME",
            "FIRST_AUTO_VAT_TYPE_SALE_NAME",
            "FIRST_AUTO_VAT_BUY_NAME",
            "FIRST_AUTO_VAT_SALE_NAME",
            "FIRST_AUTO_TEMPORARY_STORAGE_NAME",
            "FIRST_AUTO_BORDER_CROSSING_NAME",
            "ID_UNIT",
            "COMPANY_CONSIGNEE_NAME",
            "TYPE_OF_VAT_ON_PURCHASE",
            "TYPE_OF_VAT_ON_SALE",
            "TSW_TERMINAL",
            "BORDER_CROSSING",
            "PURCHASE_PLAN",
            "SALE_PLAN",
            "DATE_OF_ISSUE_CONDITIONAL_RELEASE",
            "EXECUTOR",
            "PURCHASE_CHARCODE",
            "SALE_CHARCODE",
            {
                key: "ORDER_COMPANY_PARTNER_NAME_SMALL",
                notModule: "Transline"
            },
            {
                key: "ORDER_COMPANY_PARTNER_NAME",
                module: "Transline"
            }
        ],
        plugins: [
            "ValidateUnitNumber",
            "CreateForwardDocIfNotExists",
            "CreatePortTerminalIfNotExists",
            {
                name: "FormBy",
                params: {
                    OperationUnitForm: {
                        id: "ID",
                        table: "OPERATION_UNIT"
                    },
                    EDIEventsForm: {
                        columns: ["EDI_LAST_EVENT"],
                        id: "ID",
                        table: "OPERATION_UNIT"
                    },
                    TrainForm: {
                        columns: ["TRAIN_NUMBER"],
                        id: "ID_TRAIN",
                        table: "TRAIN"
                    }
                }
            },
            "DisableEditAdditionalControlTypeIfNoForward",
            "DisableInlineEditIsArchive",
            "DisableInlineEditRailwayPoints",
            "FilterContainerStock"
        ]
    },
    operation_unit_archive: {//Грузы(архив)
        type: "Grid",
        icon: "book",
        tableName: "OPERATION_UNIT",
        tabsApi: "OPERATION_UNIT.archive",
        sysFilter: {
            IS_ARCHIVE: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 1
            }
        },
        sysFilterForCount: true,
        hideColumnsInFullMode: ["GTD_MAX_COND_DATE"],
        dataFields: [
            "DOC_PART_DATE",
            "ID_OWNER_UNIT",
            "ORDER_SYS_SERIAL_NUMBER",
            "UNIT_NUMBER",
            "ID_UNIT_CATEGORY",
            "CURRENT_SEA_DOC_ID",
            "CURRENT_SEA_DOC_NAME",
            "CURRENT_SEA_DOC_ID_VESSEL",
            "CURRENT_SEA_DOC_VESSEL_NAME",
            "CURRENT_SEA_DOC_VESSEL_MMSI",
            "CURRENT_SEA_DOC_VESSEL_MMSI_OR_UNKNOWN",
            "MAX_GTD_DATE_CLEAR",
            "MAX_GTD_DATE_RELEASE_FOR_PROCURING",
            "MAX_GTD_DATE_CONDITIONAL_CLEAR",
            "IS_ARCHIVE",

            "DATES_FORWARD_PRESENT",
            "DATES_FORWARD_EXECUTE",

            "ID_FITO_OPERATION_DOC",
            "ID_VETO_OPERATION_DOC",
            "ID_CUSTOMS_OPERATION_DOC",
            "ID_IDK_OPERATION_DOC",
            "ID_WEIGHTING_OPERATION_DOC",
            "ID_MAX_EXPED",
            "ID_MAX_SEA",
            "ID_SEA_PORT_TERMINAL_POINT",
            "ID_TRAIN",
            "IS_VISITED",
            "ID_ADDITIONAL_CONTROL_TYPE",
            "HAS_EXPED_BOOLEAN",
            "IS_CONTRACT_TEU",
            "TRAIN_NUMBER",
            {
                modules: ["Canavara"],
                fields: ["PREPARATION_GTD_DATE_TASK"]
            }
        ],
        excludeFields: [
            "FIRST_AUTO_COMPANY_EXECUTOR_NAME",
            "FIRST_AUTO_CURRENCY_COST_BUY_CHARCODE",
            "FIRST_AUTO_CURRENCY_COST_SALE_CHARCODE",
            "FIRST_AUTO_COST_BUY_TOTAL",
            "FIRST_AUTO_COST_SALE_TOTAL",
            "FIRST_AUTO_VAT_TYPE_BUY_NAME",
            "FIRST_AUTO_VAT_TYPE_SALE_NAME",
            "FIRST_AUTO_VAT_BUY_NAME",
            "FIRST_AUTO_VAT_SALE_NAME",
            "FIRST_AUTO_TEMPORARY_STORAGE_NAME",
            "FIRST_AUTO_BORDER_CROSSING_NAME",
            "ID_UNIT",
            "LAST_DAY_DETENTION",
            "COMPANY_CONSIGNEE_NAME",
            "TYPE_OF_VAT_ON_PURCHASE",
            "TYPE_OF_VAT_ON_SALE",
            "TSW_TERMINAL",
            "BORDER_CROSSING",
            "PURCHASE_PLAN",
            "SALE_PLAN",
            "DATE_OF_ISSUE_CONDITIONAL_RELEASE",
            "EXECUTOR",
            "PURCHASE_CHARCODE",
            "SALE_CHARCODE",
            {
                key: "ORDER_COMPANY_PARTNER_NAME_SMALL",
                notModule: "Transline"
            },
            {
                key: "ORDER_COMPANY_PARTNER_NAME",
                module: "Transline"
            }
        ],
        plugins: [
            "ValidateUnitNumber",
            "CreateForwardDocIfNotExists",
            "CreatePortTerminalIfNotExists",
            {
                name: "DisableInlineEditExpectedPeriod",
                params: {
                    modules: ["Eastex"]
                }
            },
            {
                name: "FormBy",
                params: {
                    OperationUnitForm: {
                        id: "ID",
                        table: "OPERATION_UNIT"
                    },
                    EDIEventsForm: {
                        columns: ["EDI_LAST_EVENT"],
                        id: "ID",
                        table: "OPERATION_UNIT"
                    },
                    TrainForm: {
                        columns: ["TRAIN_NUMBER"],
                        id: "ID_TRAIN",
                        table: "TRAIN"
                    }
                }
            },
            "DisableEditAdditionalControlTypeIfNoForward",
            "DisableInlineEditIsArchive",
            "DisableInlineEditRailwayPoints",
            "FilterContainerStock"
        ],
        prepares: [
            "ColorizeGtdFillingMinutes",
            "DetentionDemurrageColors"
        ]
    },
    operation_unit_all: {//Грузы(все)
        type: "Grid",
        icon: "book",
        tableName: "OPERATION_UNIT",
        prepares: [
            "DetentionDemurrageColors",
            "ColorizeMinDateGtdClearExpected",
            "TimexColorDateReleaseTo",
            "TransLogixColorDateReleaseTo",
            "ColorizeDriverCellInUnit",
            "ColorizeGtdFillingMinutes"
        ],
        tabsApi: "OPERATION_UNIT.all",
        hideColumnsInFullMode: ["GTD_MAX_COND_DATE"],
        dataFields: [
            "DOC_PART_DATE",
            "ID_OWNER_UNIT",
            "ORDER_SYS_SERIAL_NUMBER",
            "UNIT_NUMBER",
            "ID_UNIT_CATEGORY",
            "CURRENT_SEA_DOC_ID",
            "CURRENT_SEA_DOC_NAME",
            "CURRENT_SEA_DOC_ID_VESSEL",
            "CURRENT_SEA_DOC_VESSEL_NAME",
            "CURRENT_SEA_DOC_VESSEL_MMSI",
            "CURRENT_SEA_DOC_VESSEL_MMSI_OR_UNKNOWN",
            "GTD_READY_IS_AVAILABLE_AND_NO_START_DATE",
            "GTD_REGISTRATION_IS_AVAILABLE_AND_NO_START_DATE",
            "MAX_GTD_DATE_CLEAR",
            "MAX_GTD_DATE_RELEASE_FOR_PROCURING",
            "MAX_GTD_DATE_CONDITIONAL_CLEAR",

            "DATES_FORWARD_PRESENT",
            "DATES_FORWARD_EXECUTE",

            "ID_FITO_OPERATION_DOC",
            "ID_VETO_OPERATION_DOC",
            "ID_CUSTOMS_OPERATION_DOC",
            "ID_IDK_OPERATION_DOC",
            "ID_WEIGHTING_OPERATION_DOC",
            "ID_MAX_EXPED",
            "ID_MAX_SEA",
            "ID_SEA_PORT_TERMINAL_POINT",
            "ID_TRAIN",
            "IS_VISITED",
            "ID_ADDITIONAL_CONTROL_TYPE",
            "HAS_EXPED_BOOLEAN",
            "IS_CONTRACT_TEU",
            "TRAIN_NUMBER",
            {
                modules: ["Canavara"],
                fields: ["PREPARATION_GTD_DATE_TASK"]
            },
            "NAME_PRELIMINARY_STATUS"
        ],
        excludeFields: [
            "FIRST_AUTO_COMPANY_EXECUTOR_NAME",
            "FIRST_AUTO_CURRENCY_COST_BUY_CHARCODE",
            "FIRST_AUTO_CURRENCY_COST_SALE_CHARCODE",
            "FIRST_AUTO_COST_BUY_TOTAL",
            "FIRST_AUTO_COST_SALE_TOTAL",
            "FIRST_AUTO_VAT_TYPE_BUY_NAME",
            "FIRST_AUTO_VAT_TYPE_SALE_NAME",
            "FIRST_AUTO_VAT_BUY_NAME",
            "FIRST_AUTO_VAT_SALE_NAME",
            "FIRST_AUTO_TEMPORARY_STORAGE_NAME",
            "FIRST_AUTO_BORDER_CROSSING_NAME",
            "ID_UNIT",
            "COMPANY_CONSIGNEE_NAME",
            "TYPE_OF_VAT_ON_PURCHASE",
            "TYPE_OF_VAT_ON_SALE",
            "TSW_TERMINAL",
            "BORDER_CROSSING",
            "PURCHASE_PLAN",
            "SALE_PLAN",
            "DATE_OF_ISSUE_CONDITIONAL_RELEASE",
            "EXECUTOR",
            "PURCHASE_CHARCODE",
            "SALE_CHARCODE",
            {
                key: "ORDER_COMPANY_PARTNER_NAME_SMALL",
                notModule: "Transline"
            },
            {
                key: "ORDER_COMPANY_PARTNER_NAME",
                module: "Transline"
            }
        ],
        plugins: [
            "ValidateUnitNumber",
            "CreateForwardDocIfNotExists",
            "CreatePortTerminalIfNotExists",
            {
                name: "FormBy",
                params: {
                    OperationUnitForm: {
                        id: "ID",
                        table: "OPERATION_UNIT"
                    },
                    EDIEventsForm: {
                        columns: ["EDI_LAST_EVENT"],
                        id: "ID",
                        table: "OPERATION_UNIT"
                    },
                    TrainForm: {
                        columns: ["TRAIN_NUMBER"],
                        id: "ID_TRAIN",
                        table: "TRAIN"
                    }
                }
            },
            "DisableEditAdditionalControlTypeIfNoForward",
            "DisableInlineEditIsArchive",
            "DisableInlineEditRailwayPoints",
            "FilterContainerStock"
        ]
    },
    person_posts: {
        tableName: "LIST_PERSON_POST",
        type: "Grid"
    },
    conact_persons: {
        tableName: "LIST_CONTACT_PERSONS",
        type: "Grid",
        dataFields: ["EMAIL"],
        plugins: [
            {
                name: "ValidateMail",
                params: {
                    column: {
                        name: "EMAIL"
                    }
                }
            }
        ]
    },
    list_gtd_post_customs_control: {
        type: "Grid",
        tableName: "LIST_POST_CUSTOMS_GTD",
        prepare: []
    },
    gtd_current: {
        type: "Grid",
        tableName: "LIST_ACTIVE_GTD",
        dataFields: [
            "ID_LIST_CUSTOMS",
            "ORDERS_IDS",
            "OPERATION_UNITS_IDS",
            "DEC_UNIT_COUNT",
            "USERS_YOUR_NOTES_IDS"
        ],
        excludeFields: [
            {
                key: "LAST_COMMENT_OTO_MESSAGE",
                notModule: "Eastex"
            },
            {
                key: "USER_UNIT_GTD_FULL_NAME",
                module: "Transline"
            }
        ],
        plugins: [
            "FilterListUserPlugin"
        ]
    },
    gtd_archive: {
        icon: "external-link",
        type: "Grid",
        tableName: "LIST_ARCHIVE_GTD",
        dataFields: [
            "ID_LIST_CUSTOMS",
            "OPERATION_UNITS_IDS",
            "ORDERS_IDS",
            "DEC_UNIT_COUNT",
            "USERS_YOUR_NOTES_IDS"
        ],
        excludeFields: [
            {
                key: "LAST_COMMENT_OTO_MESSAGE",
                notModule: "Eastex"
            }
        ],
        plugins: [
            "FilterListUserPlugin"
        ]
    },
    gtd_all: {
        type: "Grid",
        tableName: "LIST_ALL_GTD",
        dataFields: [
            "ID_LIST_CUSTOMS",
            "OPERATION_UNITS_IDS",
            "ORDERS_IDS",
            "DEC_UNIT_COUNT",
            "USERS_YOUR_NOTES_IDS"
        ],
        excludeFields: [
            {
                key: "LAST_COMMENT_OTO_MESSAGE",
                notModule: "Eastex"
            }
        ],
        plugins: [
            "FilterListUserPlugin"
        ]
    },
    gtd_post_customs: {
        type: "Grid",
        tableName: "LIST_POST_CUSTOMS_GTD"
    },
    gtd_payments: {
        type: "Form2",
        form2: "BalanceGTDPaymentForm"
    },
    check_customs_payments: {
        type: "Form2",
        form2: "CheckCustomsPaymentsForm"
    },
    work_instructions: {
        type: "Form2",
        form2: "WorkInstructionsForm",
        manageRights: true
    },
    work_instructions_document: {
        type: "Grid",
        tableName: "WORK_INSTRUCTIONS_DOCUMENT"
    },
    work_instructions_category: {
        type: "Grid",
        tableName: "WORK_INSTRUCTIONS_CATEGORY"
    },
    gtd_balance: {
        type: "Form2",
        form2: "BalanceContractsFeaForm"
    },
    invoice_incoming: {
        icon: "financial_doc",
        type: "Grid",
        tableName: "INVOICE_INCOMING",
        langTableName: "INVOICE_INCOMING",
        dataFields: [
            "DOC_DATE_TRUNC",
            "DOC_DATE",
            "ACTUAL_STATUS",
            "HAS_PAYMENT_ORDER",
            "STATEMENT_DATE_LESS_THAN_DATE_IN_FIN_SETTINGS",
            "ARCHIVED_ORDER",
            "ID_INVOICE_1C_UNLOAD_TYPE",
            "HAS_CLOSED_DOCS",
            "HAS_ORDER_COMPLETED_BY_ACCAUNTANT",
            "DATE_CONFIRMATION_RESPONSIBLE_MANAGER",
            "DATE_CONFIRMATION_DIRECTOR",
            "RENOMINATION_INVOICES_STATUS",
            "IS_AUTO_CREATED_INVOICE",
            "IS_MIRROR"
        ],
        prepares: ["InvoiceStatusColors", "BaltkomplektColorInvoice"],
        excludeFields: [
            "LIST_TYPE_VAT_NAME",
            "LIST_VAT_NAME",
            {
                key: "SUM_WITH_VAT_IN_ACTUAL_CURS",
                module: "EuroAsia"
            },
            "INVOICE_PROGRESS_STATUS_NAME",
            "ICB_CUSTOMER_CODE",
            "PAYABLE_CSO",
            "IS_CLOSING_DOCUMENTS_ISSUE"
        ],
        plugins: [
            "InvoicePaymentsPlugin",
            "CheckingInvoiceForDuplicates",
            {
                name: "SetCursToFinOperation",
                params: {
                    modules: ["KTK"]
                }
            },
            {
                name: "DisableAutoCreatedInvoice",
                params: {
                    modules: ["Yusen"]
                }
            },
            "ClearInvoiceOnChangeCompany",
            "ClearIcbAndCsoDataOnChangeContractor",
            "FilterFactCodePlugin",
            {
                name: "DisableInlineEditAllColumns",
                params: [
                    {
                        message:
                            "statement_date_less_than_date_in_fin_settings_equals_1",
                        filter: {
                            isStatementDateLessThanDateInFinSettings: {
                                key: "STATEMENT_DATE_LESS_THAN_DATE_IN_FIN_SETTINGS",
                                type: "equal",
                                value: 1
                            }
                        },
                        module: "EuroAsia",
                        excludeFields: [
                            "PLAN_PAYMENT_DATE",
                            "PAYMENT_DATE",
                            "IS_CLOSING_DOC_TRANSFER",
                            "INVOICE_1C_UNLOAD_TYPE_NAME",
                            "HAS_CLOSED_DOCS"
                        ]
                    },
                    {
                        message:
                            "statement_date_less_than_date_in_fin_settings_equals_1",
                        filter: {
                            isStatementDateLessThanDateInFinSettings: {
                                key: "STATEMENT_DATE_LESS_THAN_DATE_IN_FIN_SETTINGS",
                                type: "equal",
                                value: 1
                            }
                        },
                        notModule: ["EuroAsia","DelExpress"],
                        excludeFields: [
                            "PLAN_PAYMENT_DATE",
                            "PAYMENT_DATE",
                            "IS_CLOSING_DOC_TRANSFER",
                            "INVOICE_1C_UNLOAD_TYPE_NAME"
                        ]
                    },
                    {
                        message:
                            "statement_date_less_than_date_in_fin_settings_equals_1",
                        filter: {
                            isStatementDateLessThanDateInFinSettings: {
                                key: "STATEMENT_DATE_LESS_THAN_DATE_IN_FIN_SETTINGS",
                                type: "equal",
                                value: 1
                            }
                        },
                        module: ["DelExpress"],
                        excludeFields: [
                            "PLAN_PAYMENT_DATE",
                            "PAYMENT_DATE",
                            "IS_CLOSING_DOC_TRANSFER",
                            "INVOICE_1C_UNLOAD_TYPE_NAME",
                            "REGISTER_DATE_FOR_PAYMENT"
                        ]
                    },
                    {
                        message: "has_closed_docs_equals_1",
                        filter: {
                            hasClosedDoc: {
                                key: "HAS_CLOSED_DOCS",
                                type: "equal",
                                value: "1"
                            }
                        },
                        excludeFields: [
                            "PAYMENT_DATE",
                            "IS_CLOSING_DOC_TRANSFER",
                            "INVOICE_1C_UNLOAD_TYPE_NAME",
                            "PLAN_PAYMENT_DATE",
                            "HAS_CLOSED_DOCS"
                        ]
                    },
                    {
                        message: "has_1c_unload_1",
                        module: "Spiko",
                        filter: {
                            has1cUnload: {
                                key: "ID_INVOICE_1C_UNLOAD_TYPE",
                                type: "equal",
                                value: "2"
                            }
                        },
                        excludeFields: [
                            "PAYMENT_DATE",
                            "IS_CLOSING_DOC_TRANSFER",
                            "INVOICE_1C_UNLOAD_TYPE_NAME",
                            "PLAN_PAYMENT_DATE",
                            "HAS_CLOSED_DOCS"
                        ]
                    },
                    {
                        message: "archived_order_equals_1",
                        filter: {
                            isArchivedOrder: {
                                key: "ARCHIVED_ORDER",
                                type: "equal",
                                value: 1
                            }
                        },
                        notModule: ["EuroAsia", "InterTrans"],
                        combine: [
                            {
                                excludeFields: [
                                    "PAYMENT_DATE",
                                    "PLAN_PAYMENT_DATE",
                                    "INVOICE_1C_UNLOAD_TYPE_NAME",
                                    "HAS_CLOSED_DOCS",
                                    "IS_CLOSING_DOC_TRANSFER"
                                ]
                            }
                        ]
                    },
                    {
                        message: "mirror_1",
                        notModule: ["Voskhod"],
                        filter: {
                            isMirror: {
                                key: "IS_MIRROR",
                                type: "equal",
                                value: 1
                            }
                        },
                        excludeFields: [
                            "IS_CLOSING_DOC_TRANSFER",
                            "INVOICE_1C_UNLOAD_TYPE_NAME"
                        ]
                    },
                    {
                        message: "mirror_1",
                        module: ["Voskhod"],
                        filter: {
                            isMirror: {
                                key: "IS_MIRROR",
                                type: "equal",
                                value: 1
                            }
                        },
                        excludeFields: [
                            "IS_CLOSING_DOC_TRANSFER",
                            "INVOICE_1C_UNLOAD_TYPE_NAME",
                            "ID_AGREED_STATUS",
                            "DATE_AGREED",
                            "AGREED_STATUS_NAME"
                        ]
                    }
                ]
            },
            "SetIsPaymentDateByUser"
        ],
        toolbar: {
            kit: "invoices"
        }
    },
    invoice_outgoing: {
        icon: "financial_doc",
        type: "Grid",
        tableName: "INVOICE_OUTGOING",
        langTableName: "INVOICE_OUTGOING",
        dataFields: [
            "DOC_DATE_TRUNC",
            "DOC_DATE",
            "ACTUAL_STATUS",
            "HAS_PAYMENT_ORDER",
            "STATEMENT_DATE_LESS_THAN_DATE_IN_FIN_SETTINGS",
            "ARCHIVED_ORDER",
            "ID_INVOICE_1C_UNLOAD_TYPE",
            "HAS_CLOSED_DOCS",
            "HAS_ORDER_COMPLETED_BY_ACCAUNTANT",
            "IS_CLOSING_DOCUMENTS_ISSUE",
            "DATE_CONFIRMATION_RESPONSIBLE_MANAGER",
            "ID_INVOICE_TYPE",
            "MIN_INV_POS_ID_ORDER",
            "MIN_ORDER_NUMBER"
        ],
        prepares: ["InvoiceStatusColors"],
        excludeFields: [
            "LIST_TYPE_VAT_NAME",
            "LIST_VAT_NAME",
            {
                key: "SUM_WITH_VAT_IN_ACTUAL_CURS",
                module: "EuroAsia"
            },
            "INVOICE_SUMM",
            "BALANCE",
            "ICB_VENDOR_CODE",
            "DATE_CONFIRMATION_DIRECTOR"
        ],
        plugins: [
            "InvoicePaymentsPlugin",
            "CheckingInvoiceForDuplicates",
            {
                name: "SetCursToFinOperation",
                params: {
                    modules: ["KTK"]
                }
            },
            "ClearInvoiceOnChangeCompany",
            "ClearIcbAndCsoDataOnChangeContractor",
            "FilterFactCodePlugin",
            {
                name: "DisableInlineEditAllColumns",
                params: [
                    {
                        message:
                            "statement_date_less_than_date_in_fin_settings_equals_1",
                        filter: {
                            isStatementDateLessThanDateInFinSettings: {
                                key: "STATEMENT_DATE_LESS_THAN_DATE_IN_FIN_SETTINGS",
                                type: "equal",
                                value: 1
                            }
                        },
                        module: "EuroAsia",
                        excludeFields: [
                            "DATE_SEND_CLOSED_DOCS",
                            "PAYMENT_DATE",
                            "INVOICE_1C_UNLOAD_TYPE_NAME",
                            "HAS_CLOSED_DOCS"
                        ]
                    },
                    {
                        message:
                            "statement_date_less_than_date_in_fin_settings_equals_1",
                        filter: {
                            isStatementDateLessThanDateInFinSettings: {
                                key: "STATEMENT_DATE_LESS_THAN_DATE_IN_FIN_SETTINGS",
                                type: "equal",
                                value: 1
                            }
                        },
                        module: "DelExpress",
                        excludeFields: [
                            "REGISTER_DATE_FOR_PAYMENT",
                            "DATE_SEND_CLOSED_DOCS",
                            "PAYMENT_DATE",
                            "INVOICE_1C_UNLOAD_TYPE_NAME"
                        ]
                    },
                    {
                        message:
                            "statement_date_less_than_date_in_fin_settings_equals_1",
                        filter: {
                            isStatementDateLessThanDateInFinSettings: {
                                key: "STATEMENT_DATE_LESS_THAN_DATE_IN_FIN_SETTINGS",
                                type: "equal",
                                value: 1
                            }
                        },
                        notModule: ["EuroAsia","DelExpress"],
                        excludeFields: [
                            "PAYMENT_DATE",
                            "DATE_SEND_CLOSED_DOCS",
                            "INVOICE_1C_UNLOAD_TYPE_NAME"
                        ]
                    },
                    {
                        message: "is_closing_documents_issue_1",
                        filter: {
                            isClosingDocumentsIssue: {
                                key: "IS_CLOSING_DOCUMENTS_ISSUE",
                                type: "equal",
                                value: 1
                            }
                        },
                        module: ["Canavara"],
                        excludeFields: [
                            "IS_CLOSING_DOCUMENTS_ISSUE"
                        ]
                    },
                    {
                        message: "has_closed_docs_equals_1",
                        filter: {
                            hasClosedDoc: {
                                key: "HAS_CLOSED_DOCS",
                                type: "equal",
                                value: "1"
                            }
                        },
                        notModule: "Spiko",
                        excludeFields: [
                            "PAYMENT_DATE",
                            "INVOICE_1C_UNLOAD_TYPE_NAME",
                            "DATE_SEND_CLOSED_DOCS",
                            "HAS_CLOSED_DOCS"
                        ]
                    },
                    {
                        message: "has_1c_unload_1",
                        module: "Spiko",
                        filter: {
                            has1cUnload: {
                                key: "ID_INVOICE_1C_UNLOAD_TYPE",
                                type: "equal",
                                value: "2"
                            }
                        },
                        excludeFields: [
                            "PAYMENT_DATE",
                            "IS_CLOSING_DOC_TRANSFER",
                            "INVOICE_1C_UNLOAD_TYPE_NAME",
                            "PLAN_PAYMENT_DATE",
                            "HAS_CLOSED_DOCS"
                        ]
                    },
                    {
                        message: "has_closed_docs_equals_1",
                        filter: {
                            hasClosedDoc: {
                                key: "HAS_CLOSED_DOCS",
                                type: "equal",
                                value: "1"
                            }
                        },
                        module: "Spiko",
                        excludeFields: [
                            "PAYMENT_DATE",
                            "INVOICE_1C_UNLOAD_TYPE_NAME",
                            "DATE_SEND_CLOSED_DOCS",
                            "HAS_CLOSED_DOCS",
                            "CONTRACT_PAYMENT_DATE"
                        ]
                    },
                    {
                        message: "archived_order_equals_1",
                        filter: {
                            isArchivedOrder: {
                                key: "ARCHIVED_ORDER",
                                type: "equal",
                                value: 1
                            }
                        },
                        notModule: ["EuroAsia", "InterTrans"],
                        combine: [
                            {
                                excludeFields: [
                                    "PAYMENT_DATE",
                                    "INVOICE_1C_UNLOAD_TYPE_NAME",
                                    "DATE_SEND_CLOSED_DOCS",
                                    "HAS_CLOSED_DOCS"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                notModule: ["Rusmarine"],
                name: "DisableInlineEditIsInvoice"
            },
            {
                name: "ValidateInvoice",
                params: {
                    modules: ["Yusen"]
                }
            },
            "SetIsPaymentDateByUser"
        ],
        toolbar: {
            kit: "invoices"
        }
    },
    payment_orders: {
        type: "Grid",
        tableName: "PAYMENT_ORDERS"
    },
    payments_incoming: {
        type: "Grid",
        tableName: "PAYMENT_ORDERS_INCOMING",
        sysFilterForCount: true,
        sysFilter: {
            type: {
                key: "ID_PAYMENT_ORDERS_SWIFT_TYPE",
                type: "equal",
                value: 1
            }
        },
        dataFields: [
            "IS_AUTO_CREATED_PAYMENT",
            "CUSTOM_CURS",
            "ID_INVOICE_TYPE",
            "IS_MIRROR",
            "ID_PAYMENT_ORDERS_SWIFT_TYPE"
        ],
        excludeFields: ["GTD_SUM_DIFF"],
        plugins: [
            "FilterContractPaymentPlugin",
            {
                name: "DisableInlineEditForParsedPayments",
                params: {
                    toExclude: [
                        {
                            module: "any",
                            excludeFields: [
                                "CUSTOM_CURS",
                                "VAT_NAME",
                                "VAT_TYPE_NAME",
                                "PAYMENTS_GTD_TYPE_NAME",
                                "NUMBER_CONTRACT",
                                "CONTRACTS_FEA_DOC_NUMBER",
                                "TRANSFER_POINT_GTD_NAME"
                            ],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "Baltkomplekt",
                            excludeFields: ["LIST_COMPANY_NAME_PAYER"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                },
                                isIncomingInvoiceType: {
                                    key: "ID_INVOICE_TYPE",
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "Miles",
                            excludeFields: ["LIST_COMPANY_NAME_PAYER"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                },
                                isIncomingInvoiceType: {
                                    key: "ID_INVOICE_TYPE",
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "GQLogistics",
                            excludeFields: ["LIST_COMPANY_NAME_PAYER"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                },
                                isIncomingInvoiceType: {
                                    key: "ID_INVOICE_TYPE",
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "Spiko",
                            excludeFields: ["LIST_COMPANY_NAME_PAYER"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                },
                                isIncomingInvoiceType: {
                                    key: "ID_INVOICE_TYPE",
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "Inviktika",
                            excludeFields: ["LIST_COMPANY_BANK_ACCOUNTS_FROM_ACCOUNT","LIST_COMPANY_NAME_PAYER"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                },
                                isIncomingInvoiceType: {
                                    key: "ID_INVOICE_TYPE",
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "KTK",
                            excludeFields: ["LIST_COMPANY_NAME_PAYER", "LIST_COMPANY_NAME_PAYEE"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                },
                                isIncomingInvoiceType: {
                                    key: "ID_INVOICE_TYPE",
                                    type: "equal",
                                    value: 1
                                }
                            }
                        }
                    ]
                }
            }
        ]
    },
    payments_outgoing: {
        type: "Grid",
        tableName: "PAYMENT_ORDERS_OUTGOING",
        sysFilterForCount: true,
        sysFilter: {
            type: {
                key: "ID_PAYMENT_ORDERS_SWIFT_TYPE",
                type: "equal",
                value: 1
            }
        },
        dataFields: ["IS_AUTO_CREATED_PAYMENT", "CUSTOM_CURS", "IS_MIRROR"],
        plugins: [
            "FilterContractPaymentPlugin",
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_INVOICE_TYPE: 2
                    }
                }
            },
            {
                name: "DisableInlineEditForParsedPayments",
                params: {
                    toExclude: [
                        {
                            module: "any",
                            excludeFields: [
                                "CUSTOM_CURS",
                                "VAT_NAME",
                                "VAT_TYPE_NAME",
                                "PAYMENTS_GTD_TYPE_NAME",
                                "NUMBER_CONTRACT",
                                "CONTRACTS_FEA_DOC_NUMBER",
                                "TRANSFER_POINT_GTD_NAME"
                            ],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "Baltkomplekt",
                            excludeFields: ["LIST_COMPANY_NAME_PAYEE"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "GQLogistics",
                            excludeFields: ["LIST_COMPANY_NAME_PAYEE"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "Miles",
                            excludeFields: ["LIST_COMPANY_NAME_PAYEE"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "KTK",
                            excludeFields: ["LIST_COMPANY_NAME_PAYEE"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "Spiko",
                            excludeFields: ["LIST_COMPANY_NAME_PAYEE"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        },
                        {
                            module: "Inviktika",
                            excludeFields: ["LIST_COMPANY_BANK_ACCOUNTS_TO_ACCOUNT","LIST_COMPANY_NAME_PAYEE"],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        }
                    ]
                }
            }
        ],
        excludeFields: [
            "SWIFT_33B_AMOUNT",
            "SUM_IN_FEA_CURRENCY",
            "GTD_SUM_DIFF",
            "CLIENTS",
            "ORDER_REQUEST_CURRENCY_TRANSLATION_ORDERS_NUMBERS"
        ]
    },
    payments_incoming_swift: {
        type: "Grid",
        tableName: "PAYMENT_ORDERS_INCOMING",
        sysFilterForCount: true,
        sysFilter: {
            type: {
                key: "ID_PAYMENT_ORDERS_SWIFT_TYPE",
                type: "equal",
                value: 2
            }
        },
        dataFields: ["IS_AUTO_CREATED_PAYMENT", "IS_MIRROR"],
        plugins: [
            "FilterContractPaymentPlugin",
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_PAYMENT_ORDERS_SWIFT_TYPE: 2
                    }
                }
            },
            {
                name: "DisableInlineEditForParsedPayments",
                params: {
                    toExclude: [
                        {
                            module: "any",
                            excludeFields: [
                                "CUSTOM_CURS",
                                "SWIFT_33B_AMOUNT",
                                "NUMBER_CONTRACT",
                                "PAYMENTS_GTD_TYPE_NAME",
                                "SWIFT_33B_CURRENCY_CHARCODE",
                                "CONTRACTS_FEA_DOC_NUMBER"
                            ],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        }
                    ]
                }
            }
        ],
        excludeFields: ["SUM_IN_FEA_CURRENCY", "GTD_SUM_DIFF"]
    },
    payments_outgoing_swift: {
        type: "Grid",
        tableName: "PAYMENT_ORDERS_OUTGOING",
        sysFilterForCount: true,
        sysFilter: {
            type: {
                key: "ID_PAYMENT_ORDERS_SWIFT_TYPE",
                type: "equal",
                value: 2
            }
        },
        dataFields: ["IS_AUTO_CREATED_PAYMENT", "IS_MIRROR"],
        plugins: [
            "FilterContractPaymentPlugin",
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_PAYMENT_ORDERS_SWIFT_TYPE: 2
                    }
                }
            },
            {
                name: "DisableInlineEditForParsedPayments",
                params: {
                    toExclude: [
                        {
                            module: "any",
                            excludeFields: [
                                "CUSTOM_CURS",
                                "SWIFT_33B_AMOUNT",
                                "NUMBER_CONTRACT",
                                "PAYMENTS_GTD_TYPE_NAME",
                                "SWIFT_33B_CURRENCY_CHARCODE",
                                "CONTRACTS_FEA_DOC_NUMBER"
                            ],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        }
                    ]
                }
            }
        ],
        excludeFields: [
            "SUM_IN_FEA_CURRENCY",
            "CLIENTS",
            "ORDER_REQUEST_CURRENCY_TRANSLATION_ORDERS_NUMBERS"
        ]
    },
    payments_incoming_cash: {
        type: "Grid",
        tableName: "PAYMENT_ORDERS_INCOMING",
        sysFilterForCount: true,
        sysFilter: {
            type: {
                key: "ID_PAYMENT_ORDERS_SWIFT_TYPE",
                type: "equal",
                value: 3
            }
        },
        dataFields: ["IS_AUTO_CREATED_PAYMENT", "IS_MIRROR"],
        excludeFields: ["GTD_SUM_DIFF"],
        plugins: [
            "FilterContractPaymentPlugin",
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_INVOICE_TYPE: 1,
                        ID_PAYMENT_ORDERS_SWIFT_TYPE: 3
                    }
                }
            },
            {
                name: "DisableInlineEditForParsedPayments",
                params: {
                    toExclude: [
                        {
                            module: "any",
                            excludeFields: [
                                "CUSTOM_CURS",
                                "VAT_NAME",
                                "VAT_TYPE_NAME",
                                "PAYMENTS_GTD_TYPE_NAME",
                                "NUMBER_CONTRACT",
                                "CONTRACTS_FEA_DOC_NUMBER",
                                "TRANSFER_POINT_GTD_NAME"
                            ],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        }
                    ]
                }
            }
        ]
    },
    payments_outgoing_cash: {
        type: "Grid",
        tableName: "PAYMENT_ORDERS_OUTGOING",
        sysFilterForCount: true,
        sysFilter: {
            type: {
                key: "ID_PAYMENT_ORDERS_SWIFT_TYPE",
                type: "equal",
                value: 3
            }
        },
        dataFields: ["IS_AUTO_CREATED_PAYMENT", "IS_MIRROR"],
        excludeFields: [
            "GTD_SUM_DIFF",
            "CLIENTS",
            "ORDER_REQUEST_CURRENCY_TRANSLATION_ORDERS_NUMBERS"
        ],
        plugins: [
            "FilterContractPaymentPlugin",
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_INVOICE_TYPE: 2,
                        ID_PAYMENT_ORDERS_SWIFT_TYPE: 3
                    }
                }
            },
            {
                name: "DisableInlineEditForParsedPayments",
                params: {
                    toExclude: [
                        {
                            module: "any",
                            excludeFields: [
                                "CUSTOM_CURS",
                                "VAT_NAME",
                                "VAT_TYPE_NAME",
                                "PAYMENTS_GTD_TYPE_NAME",
                                "NUMBER_CONTRACT",
                                "CONTRACTS_FEA_DOC_NUMBER",
                                "TRANSFER_POINT_GTD_NAME"
                            ],
                            filter: {
                                isNotMirror: {
                                    key: "IS_MIRROR",
                                    not: true,
                                    type: "equal",
                                    value: 1
                                }
                            }
                        }
                    ]
                }
            },
            {
                name: "CancelEditIfClosedPeriodPlugin",
                params: { entity: "PAYMENT_ORDERS_OUTGOING" }
            }
        ]
    },
    contracts: {
        type: "Grid",
        tableName: "LIST_CONTRACTS"
    },
    contracts_current: {
        type: "Grid",
        tableName: "LIST_CONTRACTS",
        tabsApi: "LIST_CONTRACTS.current",
        sysFilter: {
            IS_CURRENT: {
                key: "ARCHIVING_DATE",
                type: "composite",
                onlyNulls: true
            }
        },
        sysFilterForCount: true
    },
    contracts_all: {
        type: "Grid",
        tableName: "LIST_CONTRACTS",
        tabsApi: "LIST_CONTRACTS.all"
    },
    contracts_archive: {
        type: "Grid",
        tableName: "LIST_CONTRACTS",
        tabsApi: "LIST_CONTRACTS.archive",
        sysFilter: {
            IS_ARCHIVE: {
                key: "ARCHIVING_DATE",
                type: "composite",
                withNulls: false
            }
        },
        sysFilterForCount: true
    },
    contracts_addition: {
        type: "Grid",
        tableName: "CONTRACTS_ADDITION"
    },
    unit_type_containers: {
        type: "Grid",
        tableName: "OPERATION_UNIT_TYPE",
        sysFilterForCount: true,
        sysFilter: {
            type: {
                key: "ID_UNIT_CATEGORY",
                type: "equal",
                value: 1
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_UNIT_CATEGORY: 1
                    }
                }
            }
        ]
    },
    document_types: {
        type: "Grid",
        tableName: "LIST_TYPE_DOCUMENT",
        form2: "DocumentTypeForm"
    },
    unit_type_van: {
        type: "Grid",
        tableName: "OPERATION_UNIT_TYPE",
        excludeFields: [
            "TARE_WEIGHT_KG"
        ],
        sysFilterForCount: true,
        sysFilter: {
            type: {
                key: "ID_UNIT_CATEGORY",
                type: "equal",
                value: 2
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_UNIT_CATEGORY: 2
                    }
                }
            }
        ]
    },
    criteria: {
        type: "Grid",
        tableName: "CRITERIA_TYPE",
        form2: "CriteriaTypeForm"
    },
    unit_type_carriage: {
        type: "Grid",
        tableName: "OPERATION_UNIT_TYPE",
        excludeFields: [
            "TARE_WEIGHT_KG"
        ],
        sysFilterForCount: true,
        sysFilter: {
            type: {
                key: "ID_UNIT_CATEGORY",
                type: "in",
                value: [3, 5, 6, 7, 8, 9]
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_UNIT_CATEGORY: 3
                    }
                }
            }
        ]
    },
    class_danger: {
        type: "Grid",
        tableName: "LIST_CLASS_DANGER"
    },
    model_auto: {
        type: "Grid",
        tableName: "LIST_TYPE_MODEL_AUTO"
    },
    name_weight: {
        type: "Grid",
        tableName: "LIST_NAME_WEIGHT"
    },
    type_unit: {
        type: "Grid",
        tableName: "LIST_TYPE_UNIT"
    },
    delivery_conditions: {
        type: "Grid",
        tableName: "LIST_DELIVERY_CONDITIONS",
        access: {
            create: false,
            edit: false,
            remove: false
        }
    },
    inspectors: {
        type: "Grid",
        tableName: "LIST_CUSTOMS_INSPECTORS"
    },
    etsng: {
        type: "Grid",
        tableName: "LIST_ETSNG"
    },
    gng: {
        type: "Grid",
        tableName: "LIST_GNG"
    },
    preliminary_gtd_status: {
        type: "Grid",
        tableName: "PRELIMINARY_GTD_STATUS"
    },
    tnved: {
        type: "Grid",
        tableName: "LIST_TNVED"
    },
    gtd_fact_type: {
        type: "Grid",
        tableName: "GTD_FACT_TYPE"
    },
    country: {
        type: "Grid",
        tableName: "LIST_COUNTRY"
    },
    country_regions: {
        type: "Grid",
        tableName: "LIST_REGION"
    },
    city: {
        type: "Grid",
        tableName: "LIST_CITY"
    },
    transfer_points: {
        type: "Grid",
        tableName: "LIST_WAREHOUSE",
        toolbar: {
            kit: "manageRoles"
        }
    },
    airports: {
        type: "Grid",
        tableName: "LIST_AIRPORTS"
    },
    railways: {
        type: "Grid",
        tableName: "LIST_RAILWAYS"
    },
    curs_internal: {
        type: "Grid",
        tableName: "LIST_CURS_INTERNAL",
        sysFilter: {
            internal: {
                key: "PAR",
                type: "equal",
                value: 1
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        VALUE: null,
                        PAR: 1
                    }
                }
            }
        ]
    },
    curs_eurobank: {
        type: "Grid",
        tableName: "LIST_CURS_INTERNAL",
        sysFilter: {
            eurobank: {
                key: "PAR",
                type: "equal",
                value: 2
            }
        }
    },
    crm_request_status: {
        type: "Grid",
        tableName: "COMPANY_CRM_STATUS",
        toolbar: "readOnly"
    },
    crm_request_type: {
        type: "Grid",
        tableName: "COMPANY_CRM_TYPE_REQUEST"
    },
    crm_request_source: {
        type: "Grid",
        tableName: "CRM_REQUEST_SOURCE"
    },
    banks: {
        type: "Grid",
        tableName: "LIST_BANKS",
        plugins: ["ValidateSwift"]
    },
    contracts_type: {
        type: "Grid",
        tableName: "LIST_TYPE_CONTRACTS"
    },
    contracts_addition_type: {
        type: "Grid",
        tableName: "CONTRACTS_ADDITION_TYPE"
    },
    company: {
        type: "Grid",
        tableName: "LIST_COMPANY",
        dataFields: [
            "ID_LIST_COMPANY_LIFE_CYCLE",
            "ID_LIST_COMPANY_MARKS",
            "EMAIL"
        ],
        excludeFields: [
            {
                key: "LIST_COMPANY_GROUPS_NAME",
                module: "Timex"
            },
            {
                key: "LIST_COMPANY_MARKS_NAME",
                module: "Timex"
            },
            {
                key: "LIST_COMPANY_LIFE_CYCLE_NAME",
                module: "Timex"
            },
            "LIST_COMPANY_CATEGORY_SUPPLIER_NAME",
            "LIST_COMPANY_CATEGORY_CUSTOMER_NAME",
            {
                key: "LIST_USER_MANAGER_SALES_FULL_NAME",
                module: "Adarama"
            }
        ],
        plugins: [
            "FilterCompanyRolesPlugin",
            "ValidateCompany",
            {
                name: "ValidateMail",
                params: {
                    column: {
                        name: "EMAIL"
                    }
                }
            },
            "FilterListUserPlugin"
        ]
    },
    dislocation: {
        type: "Grid",
        tableName: "TRANSFER_DISLOCATION"
    },
    rolis_event: {
        type: "Grid",
        tableName: "ROLIS_EVENT"
    },
    rolis_edi: {
        type: "Grid",
        tableName: "ROLIS_EDI"
    },
    sea_rates: {
        type: "Grid",
        tableName: "SEA_RATES",
        plugins: ["MultipleSeaRatesFormByAdd"]
    },
    vessel: {
        type: "Grid",
        tableName: "VESSEL"
    },
    auto: {
        type: "Grid",
        tableName: "LIST_AUTO"
    },
    hook: {
        type: "Grid",
        tableName: "LIST_HOOK"
    },
    drivers: {
        type: "Grid",
        tableName: "LIST_DRIVERS"
    },
    classification: {
        type: "Grid",
        tableName: "LIST_CLASSIFICATION"
    },
    department: {
        type: "Grid",
        tableName: "DEPARTMENT"
    },
    users: {
        type: "Grid",
        tableName: "LIST_USER",
        sysFilterForCount: true,
        sysFilter: {
            notSystemUser: {
                key: "IS_SYSTEM_USER",
                type: "equal",
                value: 0
            }
        },
        dataFields: ["USER_EMAIL"],
        plugins: [
            {
                name: "ValidateMail",
                params: {
                    column: {
                        name: "USER_EMAIL"
                    }
                }
            }
        ]
    },
    tasks: {
        type: "Grid",
        icon: "tasks",
        tableName: "USER_TASK",
        dataFields: [
            "LIST_USER_WATCHER_CACHE",
            "START_RESET_LIST_USER_WATCHER_CACHE",
            "MANAGERS_IDS_AND_OWNER"
        ]
    },
    tasks_current: {
        type: "Grid",
        tableName: "USER_TASK",
        sysFilter: {
            isNotArchived: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        sysFilterForCount: true,
        dataFields: [
            "MANAGERS_IDS_AND_OWNER",
            "DATE_END",
            "DATE_END_ACTUAL",
            "ID_USER_TASK_STATUS"
        ],
        excludeFields: [
            "LAST_ARRIVAL_DATE",
            "NUMBER_BY_CLIENT",
            "MAX_GTD_DATE_CLEAR_LAST",
            "GTD_NUMBERS",
            "DOC_OPERATIONS_STATUS",
            "UNIT_STATUS_TEXT"
        ],
        plugins: [
            "FilterListUserPlugin"
        ]
    },
    tasks_archive: {
        type: "Grid",
        tableName: "USER_TASK",
        sysFilter: {
            isArchived: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 1
            }
        },
        sysFilterForCount: true,
        dataFields: [
            "MANAGERS_IDS_AND_OWNER",
            "DATE_END",
            "DATE_END_ACTUAL",
            "ID_USER_TASK_STATUS"
        ],
        excludeFields: [
            "LAST_ARRIVAL_DATE",
            "NUMBER_BY_CLIENT",
            "MAX_GTD_DATE_CLEAR_LAST",
            "GTD_NUMBERS",
            "DOC_OPERATIONS_STATUS",
            "UNIT_STATUS_TEXT"
        ],
        plugins: [
            "FilterListUserPlugin"
        ]
    },
    tasks_all: {
        type: "Grid",
        tableName: "USER_TASK",
        sysFilterForCount: true,
        dataFields: [
            "MANAGERS_IDS_AND_OWNER",
            "DATE_END",
            "DATE_END_ACTUAL",
            "ID_USER_TASK_STATUS"
        ],
        excludeFields: [
            "LAST_ARRIVAL_DATE",
            "NUMBER_BY_CLIENT",
            "MAX_GTD_DATE_CLEAR_LAST",
            "GTD_NUMBERS",
            "DOC_OPERATIONS_STATUS",
            "UNIT_STATUS_TEXT"
        ],
        plugins: [
            "FilterListUserPlugin"
        ]
    },
    tasks_operation_unit: {
        type: "Grid",
        tableName: "USER_TASK",
        tabsApi: "USER_TASK.operation_unit",
        sysFilter: {
            isNotArchived: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 0
            },
            isOperationUnitTask: {
                key: "QUERY_NAME",
                type: "equal",
                value: "OPERATION_UNIT"
            }
        },
        sysFilterForCount: true,
        dataFields: [
            "MANAGERS_IDS_AND_OWNER",
            "DATE_END",
            "DATE_END_ACTUAL",
            "ID_USER_TASK_STATUS"
        ]
    },
    list_documents: {
        type: "Grid",
        tableName: "LIST_DOCUMENTS",
        excludeFields: [
            {
                key: "COUNTERPARTY_NAME",
                notModule: "Canavara"
            }
        ]
    },
    contracts_fea_current: {
        type: "Grid",
        tableName: "CONTRACTS_FEA",
        fields: [
            "ID",
            "LIST_COMPANY_CONTRACTOR_NAME",
            "LIST_COMPANY_NAME",
            "COMPANY_NAME",
            "LIST_COUNTRY_NAME",
            "CONTRACTS_FEA_VECTOR_NAME",
            "LIST_BANKS_NAME",
            "LIST_BANKS_BIK",
            "DOC_NUMBER",
            "DOC_DATE",
            "PASSPORT_NUMBER",
            "PASSPORT_DATE",
            "SUM",
            "ACTUAL_CONTRACT_SUM",
            "LIST_CURRENCY_CHARCODE",
            "DOC_DATE_END",
            "CONDITIONS_TEXT",
            "PAY_DAYS",
            "NOTE",
            "PAYMENTS_SUM",
            "PAYMENTS_REMAINS",
            "GTD_TOTAL_PRICE",
            "GTD_REMAINS",
            "SALDO",
            "INITIAL_SALDO",
            "WEIGHT_GROUP_NAME",
            "DT_CREATE",
            "DT_UPDATE",
            "LIST_USER_NAME_CREATE",
            "LIST_USER_NAME_UPDATE",
            {
                key: "LIST_COMPANY_CLIENT_NAME",
                module: "Baltkomplekt"
            },
            {
                key: "SUM_SWIFT_33B_AMOUNT",
                module: "Baltkomplekt"
            },
            {
                key: "PAYMENTS_REAMAINS_SUM_SWIFT_33B_AMOUNT",
                module: "Baltkomplekt"
            },
            {
                key: "SALDO_SUM_SWIFT_33B_AMOUNT",
                module: "Baltkomplekt"
            }
        ],
        sysFilter: {
            notArchive: {
                key: "DATE_ARCHIVED",
                type: "composite",
                onlyNulls: true
            }
        }
    },
    contracts_fea_archive: {
        type: "Grid",
        tableName: "CONTRACTS_FEA",
        fields: [
            "ID",
            "LIST_COMPANY_CONTRACTOR_NAME",
            "LIST_COMPANY_NAME",
            "COMPANY_NAME",
            "LIST_COUNTRY_NAME",
            "CONTRACTS_FEA_VECTOR_NAME",
            "LIST_BANKS_NAME",
            "LIST_BANKS_BIK",
            "DOC_NUMBER",
            "DOC_DATE",
            "PASSPORT_NUMBER",
            "PASSPORT_DATE",
            "SUM",
            "ACTUAL_CONTRACT_SUM",
            "LIST_CURRENCY_CHARCODE",
            "DOC_DATE_END",
            "CONDITIONS_TEXT",
            "PAY_DAYS",
            "NOTE",
            "PAYMENTS_SUM",
            "PAYMENTS_REMAINS",
            "GTD_TOTAL_PRICE",
            "GTD_REMAINS",
            "SALDO",
            "INITIAL_SALDO",
            "WEIGHT_GROUP_NAME",
            "DT_CREATE",
            "DT_UPDATE",
            "LIST_USER_NAME_CREATE",
            "LIST_USER_NAME_UPDATE",
            "DATE_ARCHIVED",
            {
                key: "LIST_COMPANY_CLIENT_NAME",
                module: "Baltkomplekt"
            },
            {
                key: "SUM_SWIFT_33B_AMOUNT",
                module: "Baltkomplekt"
            },
            {
                key: "PAYMENTS_REAMAINS_SUM_SWIFT_33B_AMOUNT",
                module: "Baltkomplekt"
            },
            {
                key: "SALDO_SUM_SWIFT_33B_AMOUNT",
                module: "Baltkomplekt"
            }
        ],
        sysFilter: {
            archive: {
                key: "DATE_ARCHIVED",
                type: "composite",
                withNulls: false
            }
        }
    },
    contracts_fea_all: {
        type: "Grid",
        tableName: "CONTRACTS_FEA",
        fields: [
            "ID",
            "LIST_COMPANY_CONTRACTOR_NAME",
            "LIST_COMPANY_NAME",
            "COMPANY_NAME",
            "LIST_COUNTRY_NAME",
            "CONTRACTS_FEA_VECTOR_NAME",
            "LIST_BANKS_NAME",
            "LIST_BANKS_BIK",
            "DOC_NUMBER",
            "DOC_DATE",
            "PASSPORT_NUMBER",
            "PASSPORT_DATE",
            "SUM",
            "ACTUAL_CONTRACT_SUM",
            "LIST_CURRENCY_CHARCODE",
            "DOC_DATE_END",
            "CONDITIONS_TEXT",
            "PAY_DAYS",
            "NOTE",
            "PAYMENTS_SUM",
            "PAYMENTS_REMAINS",
            "GTD_TOTAL_PRICE",
            "GTD_REMAINS",
            "SALDO",
            "INITIAL_SALDO",
            "WEIGHT_GROUP_NAME",
            "DT_CREATE",
            "DT_UPDATE",
            "LIST_USER_NAME_CREATE",
            "LIST_USER_NAME_UPDATE",
            "DATE_ARCHIVED",
            {
                key: "LIST_COMPANY_CLIENT_NAME",
                module: "Baltkomplekt"
            },
            {
                key: "SUM_SWIFT_33B_AMOUNT",
                module: "Baltkomplekt"
            },
            {
                key: "PAYMENTS_REAMAINS_SUM_SWIFT_33B_AMOUNT",
                module: "Baltkomplekt"
            },
            {
                key: "SALDO_SUM_SWIFT_33B_AMOUNT",
                module: "Baltkomplekt"
            }
        ]
    },
    request_currency_translation: {
        icon: "exchange",
        type: "Grid",
        tableName: "REQUEST_CURRENCY_TRANSLATION"
    },
    list_vat: {
        type: "Grid",
        tableName: "LIST_VAT"
    },
    crm: {
        icon: "crm",
        type: "Grid",
        tableName: "COMPANY_CRM",
        prepares: ["CompanyCrmRowsWithOrdersToGreen", "CanavaraColorControl"],
        dataFields: [
            "STATUS_UPDATE_DATE",
            "ID_COMPANY_CRM_STATUS",
            "ORDERS_NUMBER",
            "HAS_REQUEST_ORDERS",
            "REQUEST_DATE"
        ],
        plugins: [
            "UpdateCrmRequestStatusOnInit",
            "ResetCrmRequestStatusIsAutoOnEditingStatusManually",
            "FilterListUserPlugin"
        ],
        toolbar: {
            kit: "companyCrm"
        }
    },
    crm_current: {
        icon: "crm",
        type: "Grid",
        tableName: "COMPANY_CRM",
        prepares: ["CompanyCrmRowsWithOrdersToGreen", "CanavaraColorControl"],
        dataFields: [
            "STATUS_UPDATE_DATE",
            "ID_COMPANY_CRM_STATUS",
            "ORDERS_NUMBER",
            "HAS_REQUEST_ORDERS",
            "REQUEST_DATE"
        ],
        sysFilter: {
            IS_CURRENT: {
                key: "ACTUAL_DATE_COMING",
                type: "composite",
                onlyNulls: true
            }
        },
        sysFilterForCount: true,
        plugins: [
            "UpdateCrmRequestStatusOnInit",
            "ResetCrmRequestStatusIsAutoOnEditingStatusManually",
            "FilterListUserPlugin"
        ],
        toolbar: {
            kit: "companyCrm"
        }
    },
    crm_archive: {
        icon: "crm",
        type: "Grid",
        tableName: "COMPANY_CRM",
        prepares: ["CompanyCrmRowsWithOrdersToGreen", "CanavaraColorControl"],
        dataFields: [
            "STATUS_UPDATE_DATE",
            "ID_COMPANY_CRM_STATUS",
            "ORDERS_NUMBER",
            "HAS_REQUEST_ORDERS",
            "REQUEST_DATE",
            "ACTUAL_DATE_COMING"
        ],
        sysFilter: {
            IS_CURRENT: {
                key: "ACTUAL_DATE_COMING",
                type: "composite",
                withNulls: false
            }
        },
        sysFilterForCount: true,
        plugins: [
            "DisableInlineEditIsArchive",
            "UpdateCrmRequestStatusOnInit",
            "ResetCrmRequestStatusIsAutoOnEditingStatusManually",
            "FilterListUserPlugin"
        ],
        toolbar: {
            kit: "companyCrm"
        }
    },
    crm_all: {
        icon: "crm",
        type: "Grid",
        tableName: "COMPANY_CRM",
        prepares: ["CompanyCrmRowsWithOrdersToGreen", "CanavaraColorControl"],
        dataFields: [
            "STATUS_UPDATE_DATE",
            "ID_COMPANY_CRM_STATUS",
            "ORDERS_NUMBER",
            "HAS_REQUEST_ORDERS",
            "REQUEST_DATE"
        ],
        plugins: [
            "DisableInlineEditIsArchive",
            "UpdateCrmRequestStatusOnInit",
            "ResetCrmRequestStatusIsAutoOnEditingStatusManually",
            "FilterListUserPlugin"
        ],
        toolbar: {
            kit: "companyCrm"
        }
    },
    events: {
        type: "Grid",
        tableName: "COMPANY_CRM_EVENT",
        dataFields: ["IS_CLIENT", "REFUSED"],
        prepares: ["RedIfNotDone"]
    },
    gtds_goods: {
        type: "Grid",
        tableName: "LIST_GTD_GOODS",
        access: {
            create: false
        }
    },
    leads: {
        type: "Grid",
        tableName: "LIST_COMPANY",
        tabsApi: "LIST_COMPANY.preClient",
        dataFields: ["ID_COMPANY_CRM_STATUS"],
        langTableName: "LIST_COMPANY.leads",
        fields: [
            "LAST_POINT_START",
            "LAST_POINT_END",
            "LAST_CONTAINER",
            "PRODUCTION_NAME",
            "COMPANY_CRM_TYPE_REQUEST_NAME",
            "SOURCE_REQUEST",
            "COMPANY_CRM_STATUS_NAME",
            "EVENTS_COUNT",
            "COMPANY_CRM_EVENT_IMPORTANT_NAME",
            "COMPANY_CRM_EVENT_CONNECTION_TYPE_NAME",
            "COMPANY_CRM_EVENT_TYPE_NAME",
            "EXPECTED_DATE_APPLY",
            "ACTUAL_DATE_APPLY",
            "COMPANY_CRM_EVENT_LAST_NOTE",
            "INN",
            "LIST_CONTACT_PERSONS",
            "LIST_COMPANY_NAME",
            "LIST_COMPANY_NAME_SMALL",
            "LIST_COMPANY_NAME_LARGE",
            "LIST_COMPANY_NAME_ENG",
            "LIST_FORM_NAME",
            "LIST_COUNTRY_NAME",
            "LIST_TYPE_COMPANY_NAME",
            "DT_CREATE",
            "IFNS",
            "OKVED",
            "LIST_COMPANY_GROUPS_NAME",
            "LIST_COMPANY_MARKS_NAME",
            "LIST_COMPANY_LIFE_CYCLE_NAME",
            "KPP",
            "OGRN",
            "OKPO",
            "OKATO",
            "BROKER_LICENSE",
            "PHONE",
            "PHONE2",
            "EMAIL",
            "FAX",
            "WEBSITE",
            "FINANCIAL_ROLE_NAME",
            "FINANCIAL_ROLE_INCOME_LIQUIDITY_NAME",
            "FINANCIAL_ROLE_EXPENSE_LIQUIDITY_NAME",
            "ROLES_NAMES",
            "MANAGERS_NAMES",
            "CREDIT_LIMIT",
            "PAY_DELAY_MINUTES",
            "LIST_USER_CURATOR_FULL_NAME",
            "FIRST_UR_COMPANY_ADDRESS_ADDRESS_TEXT",
            "FIRST_ACTUAL_COMPANY_ADDRESS_ADDRESS_TEXT",
            "ID",
            "NAME",
            "NOTE",
            "DT_UPDATE",
            "LIST_USER_NAME_CREATE",
            "LIST_USER_NAME_UPDATE",
            "LAST_LEAD_EVENT",
            "REQUESTS_COUNT",
            "INTERNAL_PHONE_NUMBER",
            {
                key: "GTD_POTENTIAL_PER_MONTH",
                module: "Eastex"
            }
        ],
        link: {
            WAS_LEAD: 1
        },
        sysFilter: {
            PRE_CLIENT_ROLE: {
                key: "ROLE",
                type: "equal",
                value: 24
            }
        },
        sysFilterForCount: true,
        plugins: [
            {
                name: "DefaultRole",
                params: {
                    roleId: 24
                }
            },
            "CanavaraClipboardLeads",
            "CompanyManager"
        ],
        prepares: ["ClientOlderTwoMonth"]
    },
    order_request: {
        type: "Grid",
        icon: "requests",
        tableName: "ORDER_REQUEST",
        sysFilterForCount: true,
        sysFilter: {
            visible: {
                key: "IS_VISIBLE_LOG_SCHEME",
                type: "equal",
                value: 1
            }
        },
        plugins: ["UpdateCrmRequestStatusOnEditScheme"],
        dataFields: [
            "SYS_SERIAL_NUMBER_CRM"
        ]
    },
    commercial_offer: {
        type: "Grid",
        icon: "requests",
        tableName: "ORDER_REQUEST",
        sysFilterForCount: true,
        sysFilter: {
            is_template_or_comm_offer: {
                key: "IS_TEMPLATE_OR_COMM_OFFER",
                type: "equal",
                value: 1
            }
        },
        access: {
            create: false
        },
        plugins: ["UpdateCrmRequestStatusOnEditScheme"]
    },
    order_docs_scheme: {
        type: "Grid",
        tableName: "ORDER_DOCS_SCHEME"
    },
    operation_sea: { //Букинги
        icon: "ship",
        type: "Grid",
        tableName: "OPERATION_SEA",
        sysFilterForCount: true,
        excludeFields: ["FLIGHT"],
        sysFilter: {
            notGroup: {
                key: "ID_OPERATION_GROUP_TYPE",
                type: "equal",
                value: 2
            },
            notScheme: {
                key: "IS_SCHEME",
                type: "equal",
                value: "0"
            },
            notDoc: {
                key: "ID_DOC_PARENT_OPERATION",
                type: "composite",
                onlyNulls: true
            },
            order_or_is_grouper: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_order_archive: {
                key: "IS_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        plugins: [
            {
                name: "OperationUnitLinkInSub"
            },
            "ValidateMoveType"
        ],
        dataFields: [
            "SEA_DATE_UNLOADING",
            "ARR_POINT_IDS"
        ],
        access: {
            create: false
        },
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                edit: {
                    mode: "inline"
                },
                behaviors: {
                    CellEditor: {
                        noCheckSafe: true
                    }
                },
                fields: [
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_NUMBER",
                    "NUMBER_BY_CLIENT",
                    {
                        key: "SEA_DATE_UNLOADING",
                        type: "date"
                    },
                    {
                        key: "SEA_LEAVE_UNLOADING_DIFF",
                        type: "date"
                    },
                    {
                        key: "STORE_DATE_MAX",
                        type: "date"
                    },
                    {
                        key: "STORE_DATE_MAX_REMAINS",
                        type: "minute"
                    },
                    "UNIT_CATEGORY_NAME",
                    "UNIT_TYPE_NAME",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNOR_NAME",
                    "ORDER_COMPANY_CONSIGNEE_NAME",
                    "QUANTITY",
                    "PACKING_UNIT_TYPE_ORDER_NAME",
                    "NETTO_WEIGHT",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "LDM",
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME",
                    "DATE_EMPTY_RELEASE_READY",
                    "DATE_EMPTY_RELEASE_TO",
                    "EMPTY_RELEASE_NUMBER"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },
                prepares: [
                    "SeaDateUnitLeave",
                    "StoreMaxDate",
                    "TimexColorDateReleaseTo",
                    "TransLogixColorDateReleaseTo"
                ],
                dataFields: ["SEA_DATE_UNIT_LEAVE_JSON", "STORE_DATE_MAX_JSON"],
                plugins: [
                    {
                        name: "SeaOperationUnitLeave"
                    }
                ]
            },
            OPERATION_SUB_DOC: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "OPERATION_SUB_DOC_TYPE_NAME",
                    "DOC_NUMBER",
                    "DOC_DATE",
                    "VESSEL_NAME",
                    "ARRIVAL_POINT_NAMES",
                    "UNITS_COUNT"
                ],
                link: {
                    ID_DOC_PARENT_OPERATION: "[row].ID"
                }
            },
            OPERATION_ARRIVAL_POINT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                sorts: [
                    {
                        SORT: 1
                    }
                ],
                edit: {
                    mode: "inline"
                },
                fields: [
                    "POINT_ROLE_NAME",
                    "COUNTRY_NAME",
                    "POINT_NAME",
                    "EXPECTED_DATE",
                    "ACTUAL_DATE",
                    "ACTUAL_DEPARTURE_DATE"
                ],
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID_OPERATION: "[row].ID"
                }
            }
        }
    },
    operation_auto_submenu: {
        icon: "truck",
        type: "Grid",
        tableName: "OPERATION_AUTO",
        sysFilterForCount: true,
        dataFields: [
            "ARR_POINT_IDS"
        ],
        excludeFields: ["FLIGHT"],
        sysFilter: {
            notGroup: {
                key: "ID_OPERATION_GROUP_TYPE",
                type: "equal",
                value: 2
            },
            notScheme: {
                key: "IS_SCHEME",
                type: "equal",
                value: "0"
            },
            notDoc: {
                key: "ID_DOC_PARENT_OPERATION",
                type: "composite",
                onlyNulls: true
            },
            order_or_is_grouper: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_order_archive: {
                key: "IS_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        plugins: [
            {
                name: "OperationUnitLinkInSub"
            }
        ],
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "UNIT_NUMBER",
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_CATEGORY_NAME",
                    "UNIT_TYPE_NAME",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNOR_NAME",
                    "ORDER_COMPANY_CONSIGNEE_NAME",
                    "QUANTITY",
                    "PACKING_UNIT_TYPE_ORDER_NAME",
                    "NETTO_WEIGHT",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "LDM",
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID: "[row].UNITS_IDS"
                },
                dataFields: [
                    "STORE_DATE_MAX_JSON"
                ]
            },
            OPERATION_SUB_DOC: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "OPERATION_SUB_DOC_TYPE_NAME",
                    "DOC_NUMBER",
                    "DOC_DATE",
                    "AUTO_GOS_NUMBER_AUTO",
                    "HOOK_GOS_NUMBER_HOOK",
                    "ARRIVAL_POINT_NAMES",
                    "UNITS_COUNT",
                    "DRIVER_DOCUMENT_NUM"
                ],
                link: {
                    ID_DOC_PARENT_OPERATION: "[row].ID"
                }
            },
            OPERATION_ARRIVAL_POINT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                sorts: [
                    {
                        SORT: 1
                    }
                ],
                edit: {
                    mode: "inline"
                },
                fields: [
                    "POINT_ROLE_NAME",
                    "COUNTRY_NAME",
                    "POINT_NAME",
                    "EXPECTED_DATE",
                    "ACTUAL_DATE",
                    "ACTUAL_DEPARTURE_DATE"
                ],
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID_OPERATION: "[row].ID"
                }
            }
        }
    },
    operation_air: {
        icon: "plane",
        type: "Grid",
        tableName: "OPERATION_AIR",
        sysFilterForCount: true,
        dataFields: [
            "ARR_POINT_IDS"
        ],
        sysFilter: {
            notGroup: {
                key: "ID_OPERATION_GROUP_TYPE",
                type: "equal",
                value: 2
            },
            notScheme: {
                key: "IS_SCHEME",
                type: "equal",
                value: "0"
            },
            notDoc: {
                key: "ID_DOC_PARENT_OPERATION",
                type: "composite",
                onlyNulls: true
            },
            order_or_is_grouper: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_order_archive: {
                key: "IS_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        plugins: [
            {
                name: "OperationUnitLinkInSub"
            }
        ],
        access: {
            create: false
        },
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "UNIT_NUMBER",
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_CATEGORY_NAME",
                    "UNIT_TYPE_NAME",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNOR_NAME",
                    "ORDER_COMPANY_CONSIGNEE_NAME",
                    "QUANTITY",
                    "PACKING_UNIT_TYPE_ORDER_NAME",
                    "NETTO_WEIGHT",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "LDM",
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID: "[row].UNITS_IDS"
                }
            },
            OPERATION_SUB_DOC: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "OPERATION_SUB_DOC_TYPE_NAME",
                    "DOC_NUMBER",
                    "DOC_DATE",
                    "ARRIVAL_POINT_NAMES",
                    "UNITS_COUNT"
                ],
                link: {
                    ID_DOC_PARENT_OPERATION: "[row].ID"
                }
            },
            OPERATION_ARRIVAL_POINT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                sorts: [
                    {
                        SORT: 1
                    }
                ],
                edit: {
                    mode: "inline"
                },
                fields: [
                    "POINT_ROLE_NAME",
                    "COUNTRY_NAME",
                    "POINT_NAME",
                    "EXPECTED_DATE",
                    "ACTUAL_DATE",
                    "ACTUAL_DEPARTURE_DATE"
                ],
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID_OPERATION: "[row].ID"
                }
            }
        }
    },
    operation_customs: {
        tableName: "OPERATION_CUSTOMS",
        type: "Grid",
        sysFilterForCount: true,
        sysFilter: {
            notGroup: {
                key: "ID_OPERATION_GROUP_TYPE",
                type: "equal",
                value: 2
            },
            notScheme: {
                key: "IS_SCHEME",
                type: "equal",
                value: "0"
            },
            notDoc: {
                key: "ID_DOC_PARENT_OPERATION",
                type: "composite",
                onlyNulls: true
            },
            order_or_is_grouper: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            }
        },
        plugins: [
            {
                name: "OperationUnitLinkInSub"
            }
        ],
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "UNIT_NUMBER",
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_CATEGORY_NAME",
                    "UNIT_TYPE_NAME",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNOR_NAME",
                    "ORDER_COMPANY_CONSIGNEE_NAME",
                    "QUANTITY",
                    "PACKING_UNIT_TYPE_ORDER_NAME",
                    "NETTO_WEIGHT",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "LDM",
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID: "[row].UNITS_IDS"
                }
            },
            OPERATION_SUB_DOC: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "OPERATION_SUB_DOC_TYPE_NAME",
                    "DOC_NUMBER",
                    "DOC_DATE",
                    "ARRIVAL_POINT_NAMES",
                    "UNITS_COUNT"
                ],
                link: {
                    ID_DOC_PARENT_OPERATION: "[row].ID"
                }
            },
            OPERATION_ARRIVAL_POINT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                sorts: [
                    {
                        SORT: 1
                    }
                ],
                edit: {
                    mode: "inline"
                },
                fields: [
                    "POINT_ROLE_NAME",
                    "COUNTRY_NAME",
                    "POINT_NAME",
                    "EXPECTED_DATE",
                    "ACTUAL_DATE",
                    "ACTUAL_DEPARTURE_DATE"
                ],
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID_OPERATION: "[row].ID"
                }
            }
        }
    },
    operation_train: {
        icon: "train",
        type: "Grid",
        tableName: "OPERATION_TRAIN",
        sysFilterForCount: true,
        sysFilter: {
            notGroup: {
                key: "ID_OPERATION_GROUP_TYPE",
                type: "equal",
                value: 2
            },
            notScheme: {
                key: "IS_SCHEME",
                type: "equal",
                value: "0"
            },
            notDoc: {
                key: "ID_DOC_PARENT_OPERATION",
                type: "composite",
                onlyNulls: true
            },
            order_or_is_grouper: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_order_archive: {
                key: "IS_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        plugins: [
            {
                name: "OperationUnitLinkInSub"
            }
        ],
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "UNIT_NUMBER",
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_CATEGORY_NAME",
                    "UNIT_TYPE_NAME",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNOR_NAME",
                    "ORDER_COMPANY_CONSIGNEE_NAME",
                    "QUANTITY",
                    "PACKING_UNIT_TYPE_ORDER_NAME",
                    "NETTO_WEIGHT",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "LDM",
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID: "[row].UNITS_IDS"
                }
            },
            OPERATION_SUB_DOC: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "OPERATION_SUB_DOC_TYPE_NAME",
                    "DOC_NUMBER",
                    "DOC_DATE",
                    "ARRIVAL_POINT_NAMES",
                    "UNITS_COUNT"
                ],
                link: {
                    ID_DOC_PARENT_OPERATION: "[row].ID"
                }
            },
            OPERATION_ARRIVAL_POINT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                sorts: [
                    {
                        SORT: 1
                    }
                ],
                edit: {
                    mode: "inline"
                },
                fields: [
                    "POINT_ROLE_NAME",
                    "COUNTRY_NAME",
                    "POINT_NAME",
                    "EXPECTED_DATE",
                    "ACTUAL_DATE",
                    "ACTUAL_DEPARTURE_DATE"
                ],
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID_OPERATION: "[row].ID"
                }
            }
        }
    },
    operation_forward: {
        type: "Grid",
        tableName: "OPERATION_FORWARD",
        sysFilterForCount: true,
        sysFilter: {
            id_active_log_oper_type: {
                key: "ID_ACTIVE_LOG_OPER_TYPE",
                type: "equal",
                value: 7
            },
            notGroup: {
                key: "ID_OPERATION_GROUP_TYPE",
                type: "equal",
                value: 2
            },
            notScheme: {
                key: "IS_SCHEME",
                type: "equal",
                value: "0"
            },
            order_or_is_grouper: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            }
        },
        dataFields: [
            "ID_FIRST_PREVIOUS_SEA_OPERATION",
            "IS_FEEDER_SAME_RECEIVED_DATE",
            "IDS_FEEDER_DOCS",
            "ID_FIRST_ADDITIONAL_CONTROL_TYPE",
            "MORE_THAN_ONE_ADDITIONAL_CONTROL_TYPE",
            "UNITS_IDS",
            "COUNT_FEEDERS"
        ],
        excludeFields: [
            {
                key: "DU_DATE",
                module: "Yusen"
            },
            {
                key: "DATE_DO1",
                module: "Yusen"
            }
        ],
        access: {
            create: false
        },
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                edit: {
                    mode: "inline"
                },
                fields: [
                    "UNIT_NUMBER",
                    "UNLOAD_IN_PORT_DATE",
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_CATEGORY_NAME",
                    "UNIT_TYPE_NAME",
                    "FEEDER_DOCS_RECIEVED_DATE",
                    "FEEDER_DOCS_SENT_DATE",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNOR_NAME",
                    "DATE_RELEASE_READY",
                    "DATE_RELEASE_TO",
                    "RELEASE_NUMBER",
                    "STOREHOUSE_CLOSING_DATE",
                    {
                        key: "STORE_DATE_MAX",
                        type: "date"
                    },
                    {
                        key: "STORE_DATE_MAX_REMAINS",
                        type: "minute"
                    },
                    "QUANTITY",
                    "PACKING_UNIT_TYPE_ORDER_NAME",
                    "NETTO_WEIGHT",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "LDM",
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME",
                    "DU_DATE",
                    "DATE_DO1"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },

                dataFields: ["ID_UNIT_CATEGORY", "STORE_DATE_MAX_JSON"],
                prepares: ["StoreMaxDateByPrevSea"],
                plugins: [
                    {
                        name: "InlineFilter",
                        params: {
                            columns: [
                                {
                                    name: "UNIT_TYPE_NAME",
                                    filterBy: {
                                        fields: {
                                            ID_UNIT_CATEGORY:
                                                "ID_UNIT_CATEGORY"
                                        }
                                    }
                                }
                            ]
                        }
                    },
                    {
                        name: "StoreMaxDateByPrevSea"
                    }
                ]
            },
            OPERATION_SUB_DOC: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "OPERATION_SUB_DOC_TYPE_NAME",
                    "DOC_NUMBER",
                    "DOC_DATE",
                    "ARRIVAL_POINT_NAMES",
                    "DATE_FORWARD_PRESENT",
                    "DATE_FORWARD_EXECUTE",
                    "UNITS_COUNT"
                ],
                link: {
                    ID_DOC_PARENT_OPERATION: "[row].ID"
                }
            },
            OPERATION_ARRIVAL_POINT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                sorts: [
                    {
                        SORT: 1
                    }
                ],
                edit: {
                    mode: "inline"
                },
                fields: [
                    "POINT_ROLE_NAME",
                    "COUNTRY_NAME",
                    "POINT_NAME",
                    "EXPECTED_DATE",
                    "ACTUAL_DATE",
                    "ACTUAL_DEPARTURE_DATE"
                ],
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID_OPERATION: "[row].ID"
                }
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_OPERATION_TYPE: 7
                    }
                }
            },
            {
                name: "OperationUnitLinkInSub"
            },
            {
                name: "FormBy",
                params: {
                    OperationForm: {
                        columns: [
                            "PREV_SEA_OCEAN_DOC_NUMBERS",
                            "PREV_SEA_FEEDER_DOC_NUMBERS",
                            "PREV_SEA_OCEAN_VESSEL_NAMES",
                            "PREV_SEA_FEEDER_VESSEL_NAMES",
                            "PREV_SEA_OCEAN_SEA_LINES",
                            "PREV_SEA_FEEDER_SEA_LINES"
                        ],
                        id: "ID_FIRST_PREVIOUS_SEA_OPERATION",
                        table: "OPERATION_SEA"
                    }
                }
            },
            "DisableInlineEditReceivedDateOperations",
            "DisableEditAdditionalControlType",
            "DisableInlineEditPevSeaFeeder"
        ]
    },
    operation_sub_doc_auto: {
        type: "Grid",
        icon: "truck",
        tableName: "OPERATION_SUB_DOC",
        tabsApi: "OPERATION_SUB_DOC.auto",
        sysFilter: {
            type: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 1
            },
            valid: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_doc_parent_order_archive: {
                key: "IS_DOC_PARENT_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        sysFilterForCount: true,
        access: {
            create: false
        },
        dataFields: [
            "ID_FIRST_PREVIOUS_SEA_OPERATION",
            "INVOICES_BUY_IDS",
            "IS_LOGIST_RATES",
            "IS_LOGIST_EXPORT_RATES",
            "IS_COMPLETE_RATES"
        ],
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                edit: {
                    mode: "inline"
                },
                fields: [
                    "UNIT_NUMBER",
                    "UNLOAD_IN_PORT_DATE",
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_CATEGORY_NAME",
                    "UNIT_TYPE_NAME",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNOR_NAME",
                    "ORDER_COMPANY_CONSIGNEE_NAME",
                    "DATE_RELEASE_READY",
                    "DATE_RELEASE_TO",
                    "RELEASE_NUMBER",
                    "STOREHOUSE_CLOSING_DATE",
                    {
                        key: "STORE_DATE_MAX",
                        type: "date"
                    },
                    {
                        key: "STORE_DATE_MAX_REMAINS",
                        type: "minute"
                    },
                    "QUANTITY",
                    "PACKING_UNIT_TYPE_ORDER_NAME",
                    "NETTO_WEIGHT",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "LDM",
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME",
                    "DATE_TELEX_RELEASE"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID: "[row].UNITS_IDS"
                },
                dataFields: ["ID_UNIT_CATEGORY", "STORE_DATE_MAX_JSON"],
                prepares: ["StoreMaxDateByPrevSea"],
                plugins: [
                    {
                        name: "InlineFilter",
                        params: {
                            columns: [
                                {
                                    name: "UNIT_TYPE_NAME",
                                    filterBy: {
                                        fields: {
                                            ID_UNIT_CATEGORY:
                                                "ID_UNIT_CATEGORY"
                                        }
                                    }
                                }
                            ]
                        }
                    },
                    {
                        name: "StoreMaxDateByPrevSea"
                    }
                ]
            }
        },
        plugins: [
            {
                name: "OperationUnitLinkInSub"
            },
            {
                name: "OperationAutoPluginDisabled"
            }
        ],
        excludeFields: ["PAYMENT_TYPE_HBL_NAME","HBL_NUMBER"]
    },
    operation_sub_doc_auto_current: { //TTH/CMR (текущие)
        type: "Grid",
        icon: "truck",
        tableName: "OPERATION_SUB_DOC",
        dataFields: [
            "ARR_POINT_IDS"
        ],
        sysFilter: {
            type: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 1 // Автомобильные
            },
            IS_CURRENT: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        access: {
            create: false
        },
        sysFilterForCount: true,
        excludeFields: [
            "ORDER_DATE",
            "PAYMENT_TYPE_HBL_NAME","HBL_NUMBER",
            {
                key: "UNIT_NUMBER_ORDER",
                notModule: "Transline"
            }
        ],
        plugins: [
            "FilterContainerStock"
        ]
    },
    operation_sub_doc_auto_all: {//TTH/CMR (все)
        type: "Grid",
        icon: "truck",
        tableName: "OPERATION_SUB_DOC",
        dataFields: [
            "ARR_POINT_IDS"
        ],
        sysFilter: {
            type: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 1 // Автомобильные
            }
        },
        access: {
            create: false
        },
        sysFilterForCount: true,
        excludeFields: [
            "ORDER_DATE",
            "PAYMENT_TYPE_HBL_NAME","HBL_NUMBER",
            {
                key: "UNIT_NUMBER_ORDER",
                notModule: "Transline"
            }
        ],
        plugins: [
            "FilterContainerStock"
        ]
    },
    operation_sub_doc_auto_archive: {//TTH/CMR (архив)
        type: "Grid",
        icon: "truck",
        tableName: "OPERATION_SUB_DOC",
        dataFields: [
            "ARR_POINT_IDS"
        ],
        sysFilter: {
            type: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 1 // Автомобильные
            },
            IS_ARCHIVE: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 1
            }
        },
        access: {
            create: false
        },
        sysFilterForCount: true,
        excludeFields: [
            "ORDER_DATE",
            "PAYMENT_TYPE_HBL_NAME","HBL_NUMBER",
            {
                key: "UNIT_NUMBER_ORDER",
                notModule: "Transline"
            }
        ],
        plugins: [
            "FilterContainerStock"
        ]
    },
    auto_transportation_current: {
        type: "Grid",
        tableName: "OPERATION_UNIT",
        tabsApi: "OPERATION_UNIT.auto_transportation_current",
        fields: [
            "ID",
            "UNIT_NUMBER",
            "ORDER_DATE",
            "ORDER_SYS_SERIAL_NUMBER",
            "ORDER_POINT_START_NAME",
            "ORDER_POINT_END_NAME",
            "ORDER_COMPANY_CONSIGNEE_NAME",
            "ORDER_COMPANY_CONSIGNOR_NAME",
            "ORDER_COMPANY_CLIENT_NAME",
            "NUMBER_BY_CLIENT",
            "FIRST_AUTO_VAT_BUY_NAME",
            "FIRST_AUTO_VAT_SALE_NAME",
            "GROUP_NUMBERS",
            "ORDER_COMPANY_PARTNER_NAME",
            "LIST_NAME_WEIGHT_NAME",
            "ORDER_USER_OPERATIONS_FULL_NAME",
            "ORDER_USER_LOGIST_FULL_NAME",
            "UNIT_DIVISION_NAME",
            "ORDER_TYPE_NAME",
            "STATUS_POINT_START_EXPECTED_DATE",
            "STATUS_POINT_START_ACTUAL_DEPARTURE_DATE",
            "STATUS_POINT_END_EXPECTED_DATE",
            "STATUS_POINT_END_ACTUAL_DATE",
            "MAX_GTD_DATE_CLEAR",
            "MIN_DATE_GTD_CLEAR_EXPECTED",
            "LAST_STATUS_ROUTE",
            "LAST_COMMENT",
            "UNIT_STATUS_TEXT",
            "STATUS_POINT_CURRENT_NAME",
            "POINT_CBX_NAME",
            "COUNTRY_START_NAME",
            "CARGO_COST",
            "CURRENCY_CARGO_COST_CHARCODE",
            "AUTO_UNIT_NUMBERS",
            "NOTE",
            "TYPE_OF_VAT_ON_PURCHASE",
            "TYPE_OF_VAT_ON_SALE",
            "TSW_TERMINAL",
            "BORDER_CROSSING",
            "PURCHASE_PLAN",
            "SALE_PLAN",
            "DATE_OF_ISSUE_CONDITIONAL_RELEASE",
            "EXECUTOR",
            "PURCHASE_CHARCODE",
            "SALE_CHARCODE",
            {
                key: "ORDER_USER_EXPORT_FULL_NAME",
                module: "Canavara"
            },
            {
                key: "IS_LOGIST_RATES",
                module: "Canavara"
            },
            {
                key: "IS_LOGIST_EXPORT_RATES",
                module: "Canavara"
            },
            {
                key: "BUY_COST",
                module: "Canavara"
            },
            {
                key: "SELL_COST",
                module: "Canavara"
            }
        ],
        dataFields: [
            "ID_FIRST_AUTO",
            "ID_ORDER_COMPANY_CLIENT",
            "ID_ORDER_COMPANY_PARTNER",
            "IS_COMPLETE_RATES",
            "IS_LOGIST_RATES",
            "IS_LOGIST_EXPORT_RATES"
        ],
        sysFilter: {
            orderType: {
                key: "ID_ORDER_TYPE2",
                type: "in",
                value: [
                    3, // FTL
                    4 // LTL
                ]
            },
            isArchived: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        plugins: [
            "ValidateUnitNumber",
            {
                name: "DisableInlineEdit",
                params: [
                    {
                        fields: [
                            "ORDER_SYS_SERIAL_NUMBER",
                            "ORDER_COMPANY_CONSIGNEE_NAME",
                            "ORDER_COMPANY_CONSIGNOR_NAME",
                            "ORDER_COMPANY_CLIENT_NAME"
                        ]
                    }
                ]
            }
        ],
        sysFilterForCount: true,
        toolbar: {
            kit: [
                "edit",
                "delete",
                "styles",
                "columns",
                "filters",
                "clone",
                "reload",
                "export",
                "task",
                "chat",
                "changeLog",
                "trash",
                "reports",
                "rowsLength",
                "search"
            ]
        },
        form2: "AutoTransportationForm"
    },
    auto_transportation_archive: {
        type: "Grid",
        tableName: "OPERATION_UNIT",
        tabsApi: "OPERATION_UNIT.auto_transportation_archive",
        fields: [
            "ID",
            "UNIT_NUMBER",
            "ORDER_DATE",
            "ORDER_SYS_SERIAL_NUMBER",
            "ORDER_POINT_START_NAME",
            "ORDER_POINT_END_NAME",
            "ORDER_COMPANY_CONSIGNEE_NAME",
            "ORDER_COMPANY_CONSIGNOR_NAME",
            "ORDER_COMPANY_CLIENT_NAME",
            "NUMBER_BY_CLIENT",
            "FIRST_AUTO_VAT_BUY_NAME",
            "FIRST_AUTO_VAT_SALE_NAME",
            "GROUP_NUMBERS",
            "ORDER_COMPANY_PARTNER_NAME",
            "LIST_NAME_WEIGHT_NAME",
            "ORDER_USER_OPERATIONS_FULL_NAME",
            "ORDER_USER_LOGIST_FULL_NAME",
            "UNIT_DIVISION_NAME",
            "ORDER_TYPE_NAME",
            "STATUS_POINT_START_EXPECTED_DATE",
            "STATUS_POINT_START_ACTUAL_DEPARTURE_DATE",
            "STATUS_POINT_END_EXPECTED_DATE",
            "STATUS_POINT_END_ACTUAL_DATE",
            "MAX_GTD_DATE_CLEAR",
            "MIN_DATE_GTD_CLEAR_EXPECTED",
            "LAST_STATUS_ROUTE",
            "LAST_COMMENT",
            "UNIT_STATUS_TEXT",
            "STATUS_POINT_CURRENT_NAME",
            "POINT_CBX_NAME",
            "COUNTRY_START_NAME",
            "CARGO_COST",
            "CURRENCY_CARGO_COST_CHARCODE",
            "AUTO_UNIT_NUMBERS",
            "NOTE",
            "TYPE_OF_VAT_ON_PURCHASE",
            "TYPE_OF_VAT_ON_SALE",
            "TSW_TERMINAL",
            "BORDER_CROSSING",
            "PURCHASE_PLAN",
            "SALE_PLAN",
            "DATE_OF_ISSUE_CONDITIONAL_RELEASE",
            "EXECUTOR",
            "PURCHASE_CHARCODE",
            "SALE_CHARCODE",
            {
                key: "ORDER_USER_EXPORT_FULL_NAME",
                module: "Canavara"
            },
            {
                key: "IS_LOGIST_RATES",
                module: "Canavara"
            },
            {
                key: "IS_LOGIST_EXPORT_RATES",
                module: "Canavara"
            },
            {
                key: "BUY_COST",
                module: "Canavara"
            },
            {
                key: "SELL_COST",
                module: "Canavara"
            }
        ],
        dataFields: [
            "ID_FIRST_AUTO",
            "ID_ORDER_COMPANY_CLIENT",
            "ID_ORDER_COMPANY_PARTNER",
            "IS_COMPLETE_RATES",
            "IS_LOGIST_RATES",
            "IS_LOGIST_EXPORT_RATES"
        ],
        sysFilter: {
            orderType: {
                key: "ID_ORDER_TYPE2",
                type: "in",
                value: [
                    3, // FTL
                    4 // LTL
                ]
            },
            isArchived: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 1
            }
        },
        plugins: [
            "ValidateUnitNumber",
            {
                name: "DisableInlineEdit",
                params: [
                    {
                        fields: [
                            "ORDER_SYS_SERIAL_NUMBER",
                            "ORDER_COMPANY_CONSIGNEE_NAME",
                            "ORDER_COMPANY_CONSIGNOR_NAME",
                            "ORDER_COMPANY_CLIENT_NAME"
                        ]
                    }
                ]
            }
        ],
        sysFilterForCount: true,
        toolbar: {
            kit: [
                "edit",
                "delete",
                "styles",
                "columns",
                "filters",
                "clone",
                "reload",
                "export",
                "task",
                "chat",
                "changeLog",
                "trash",
                "reports",
                "rowsLength",
                "search"
            ]
        },
        form2: "AutoTransportationForm"
    },
    auto_transportation_all: {
        type: "Grid",
        tableName: "OPERATION_UNIT",
        tabsApi: "OPERATION_UNIT.auto_transportation_all",
        fields: [
            "ID",
            "UNIT_NUMBER",
            "ORDER_DATE",
            "ORDER_SYS_SERIAL_NUMBER",
            "ORDER_POINT_START_NAME",
            "ORDER_POINT_END_NAME",
            "ORDER_COMPANY_CONSIGNEE_NAME",
            "ORDER_COMPANY_CONSIGNOR_NAME",
            "ORDER_COMPANY_CLIENT_NAME",
            "NUMBER_BY_CLIENT",
            "FIRST_AUTO_VAT_BUY_NAME",
            "FIRST_AUTO_VAT_SALE_NAME",
            "GROUP_NUMBERS",
            "ORDER_COMPANY_PARTNER_NAME",
            "LIST_NAME_WEIGHT_NAME",
            "ORDER_USER_OPERATIONS_FULL_NAME",
            "ORDER_USER_LOGIST_FULL_NAME",
            "UNIT_DIVISION_NAME",
            "ORDER_TYPE_NAME",
            "STATUS_POINT_START_EXPECTED_DATE",
            "STATUS_POINT_START_ACTUAL_DEPARTURE_DATE",
            "STATUS_POINT_END_EXPECTED_DATE",
            "STATUS_POINT_END_ACTUAL_DATE",
            "MAX_GTD_DATE_CLEAR",
            "MIN_DATE_GTD_CLEAR_EXPECTED",
            "LAST_STATUS_ROUTE",
            "LAST_COMMENT",
            "UNIT_STATUS_TEXT",
            "STATUS_POINT_CURRENT_NAME",
            "POINT_CBX_NAME",
            "COUNTRY_START_NAME",
            "CARGO_COST",
            "CURRENCY_CARGO_COST_CHARCODE",
            "AUTO_UNIT_NUMBERS",
            "NOTE",
            "GROSS_WEIGHT",
            "QUANTITY",
            "QUANTITY_PALLET",
            "VOLUME",
            "LDM",
            "STOCK_NUMBER",
            "TYPE_OF_VAT_ON_PURCHASE",
            "TYPE_OF_VAT_ON_SALE",
            "TSW_TERMINAL",
            "BORDER_CROSSING",
            "PURCHASE_PLAN",
            "SALE_PLAN",
            "DATE_OF_ISSUE_CONDITIONAL_RELEASE",
            "EXECUTOR",
            "PURCHASE_CHARCODE",
            "SALE_CHARCODE",
            {
                key: "ORDER_USER_EXPORT_FULL_NAME",
                module: "Canavara"
            },
            {
                key: "IS_LOGIST_RATES",
                module: "Canavara"
            },
            {
                key: "IS_LOGIST_EXPORT_RATES",
                module: "Canavara"
            },
            {
                key: "BUY_COST",
                module: "Canavara"
            },
            {
                key: "SELL_COST",
                module: "Canavara"
            }
        ],
        dataFields: [
            "ID_FIRST_AUTO",
            "ID_ORDER_COMPANY_CLIENT",
            "ID_ORDER_COMPANY_PARTNER",
            "IS_COMPLETE_RATES",
            "IS_LOGIST_RATES",
            "IS_LOGIST_EXPORT_RATES"
        ],
        sysFilter: {
            orderType: {
                key: "ID_ORDER_TYPE2",
                type: "in",
                value: [
                    3, // FTL
                    4 // LTL
                ]
            }
        },
        plugins: [
            "ValidateUnitNumber",
            {
                name: "DisableInlineEdit",
                params: [
                    {
                        fields: [
                            "ORDER_SYS_SERIAL_NUMBER",
                            "ORDER_COMPANY_CONSIGNEE_NAME",
                            "ORDER_COMPANY_CONSIGNOR_NAME",
                            "ORDER_COMPANY_CLIENT_NAME"
                        ]
                    }
                ]
            }
        ],
        sysFilterForCount: true,
        toolbar: {
            kit: [
                "edit",
                "delete",
                "styles",
                "columns",
                "filters",
                "clone",
                "reload",
                "export",
                "task",
                "chat",
                "changeLog",
                "trash",
                "reports",
                "rowsLength",
                "search"
            ]
        },
        form2: "AutoTransportationForm"
    },
    operation_sub_doc_train_all: { //Железнодорожные (все)
        type: "Grid",
        icon: "train",
        tableName: "OPERATION_SUB_DOC",
        dataFields: [
            "ARR_POINT_IDS"
        ],
        tabsApi: "OPERATION_SUB_DOC.train_all",
        sysFilter: {
            type: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 2
            },
            valid: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            }
        },
        sysFilterForCount: true,
        access: {
            create: false
        },
        excludeFields: [
            "REASON_BEING_LATE_NAME",
            "ORDER_DATE",
            "PAYMENT_TYPE_HBL_NAME",
            "WAREHOUSE_DATE_UNLOADING",
            "HBL_NUMBER",
            "UNIT_NUMBER_ORDER",
            "CARGO_CONDITION_NAME",
            "CARGO_INFORMING_NAME",
            "CONTAINER_STOCK_NAME"
        ]
    },
    operation_sub_doc_train_current: { //Железнодорожные (текущие)
        type: "Grid",
        icon: "train",
        tableName: "OPERATION_SUB_DOC",
        dataFields: [
            "ARR_POINT_IDS"
        ],
        tabsApi: "OPERATION_SUB_DOC.train_current",
        sysFilter: {
            type: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 2
            },
            valid: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            IS_ARCHIVE: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        sysFilterForCount: true,
        access: {
            create: false
        },
        excludeFields: [
            "REASON_BEING_LATE_NAME",
            "WAREHOUSE_DATE_UNLOADING",
            "ORDER_DATE",
            "PAYMENT_TYPE_HBL_NAME",
            "HBL_NUMBER",
            "UNIT_NUMBER_ORDER",
            "CARGO_CONDITION_NAME",
            "CARGO_INFORMING_NAME",
            "CONTAINER_STOCK_NAME"
        ]
    },
    operation_sub_doc_train_archive: { //Железнодорожные (архив)
        type: "Grid",
        icon: "train",
        tableName: "OPERATION_SUB_DOC",
        dataFields: [
            "ARR_POINT_IDS"
        ],
        tabsApi: "OPERATION_SUB_DOC.train_archive",
        sysFilter: {
            type: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 2
            },
            valid: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            IS_ARCHIVE: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 1
            }
        },
        sysFilterForCount: true,
        access: {
            create: false
        },
        excludeFields: [
            "REASON_BEING_LATE_NAME",
            "WAREHOUSE_DATE_UNLOADING",
            "ORDER_DATE",
            "PAYMENT_TYPE_HBL_NAME",
            "HBL_NUMBER",
            "UNIT_NUMBER_ORDER",
            "CARGO_CONDITION_NAME",
            "CARGO_INFORMING_NAME",
            "CONTAINER_STOCK_NAME"
        ]
    },
    operation_sub_doc_forward: {
        type: "Grid",
        tableName: "OPERATION_SUB_DOC",
        sysFilter: {
            type: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 7
            },
            valid: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_doc_parent_order_archive: {
                key: "IS_DOC_PARENT_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        sysFilterForCount: true,
        tabsApi: "OPERATION_SUB_DOC.forward",
        access: {
            create: false
        },
        fields: [
            "ID",
            "OPERATION_SUB_DOC_TYPE_NAME",
            "DOC_NUMBER",
            "PARENT_ORDER_DATE",
            "DOC_DATE",
            "DT_CREATE",
            "ETA_DATE",
            "ARRIVAL_POINT_NAMES",
            "UNITS_COUNT",
            "DATE_FORWARD_PRESENT",
            "DATE_FORWARD_EXECUTE",
            {
                key: "SAMPLING_REPORT_NUMBER",
                module: "Transline"
            },
            {
                key: "SAMPLE_COLLECTION_NAME",
                module: "Transline"
            },
            {
                key: "STOCK_NAME",
                module: "Transline"
            },
            {
                key: "COUNTRY_ORIGIN_NAME",
                module: "Transline"
            },
            {
                key: "LIST_NAME_WEIGHT_NAME",
                module: "Transline"
            },
            {
                key: "MARKING",
                module: "Transline"
            },
            {
                key: "PRODUCTION_DATE",
                module: "Transline"
            },
            {
                key: "SEATS_NUMBER",
                module: "Transline"
            },
            {
                key: "WEIGHT",
                module: "Transline"
            },
            {
                key: "IMPORT_PERMIT",
                module: "Transline"
            },
            {
                key: "VET_CERTIFICATE",
                module: "Transline"
            },
            {
                key: "OLD_FILLING",
                module: "Transline"
            },
            {
                key: "NEW_FILLING",
                module: "Transline"
            },
            {
                key: "GET_VET_VERIFIER",
                module: "Transline"
            },
            {
                key: "PLANNED_VET_INSPECTION",
                module: "Transline"
            },
            {
                key: "ACTUAL_VET_INSPECTION",
                module: "Transline"
            },
            "UNITS_NUMBERS",
            "DOC_PARENT_ORDER_SYS_SERIAL_NUMBER",
            "DOC_PARENT_ORDER_NUMBER_BY_CLIENT",
            "DOC_PARENT_ORDER_FORWARD_TYPE_NAME",
            "DOC_PARENT_ORDER_COMPANY_CLIENT_NAME",
            "DOC_PARENT_ORDER_COMPANY_PARTNER_NAME",
            "COMPANY_EXECUTOR_NAME",
            "DOC_PARENT_COMPANY_CONSIGNOR_NAME",
            "DOC_PARENT_COMPANY_CONSIGNEE_NAME",
            "ADDITIONAL_CONTROL_TYPE_NAME",
            "LIST_CLASS_DANGER_CODE",
            "DATE_RELEASE_READY",
            "DATE_RELEASE_TO",
            "LIST_USER_NAME_CREATE",
            "COUNTRY_ORIGIN_UNIT_NAME",
            "DECONTAMINATION_INFORMATION",
            "IS_SET_DOCUMENT_COMPILED",
            "DOCUMENT_DEPARTMENT_LOGIST_NAME",
            "DATE_FILLING_UNITS",
            "UNITS_DOC_OPERATIONS_STATUSES",
            "UNITS_STATUSES"
        ],
        excludeFields: [
            "PAYMENT_TYPE_HBL_NAME",
            "HBL_NUMBER"
        ],
        dataFields: ["ID_FIRST_PREVIOUS_SEA_OPERATION"],
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                edit: {
                    mode: "inline"
                },
                fields: [
                    "UNIT_NUMBER",
                    "UNLOAD_IN_PORT_DATE",
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_CATEGORY_NAME",
                    "UNIT_TYPE_NAME",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNOR_NAME",
                    "ORDER_COMPANY_CONSIGNEE_NAME",
                    "DATE_RELEASE_READY",
                    "DATE_RELEASE_TO",
                    {
                        key: "STORE_DATE_MAX",
                        type: "date"
                    },
                    {
                        key: "STORE_DATE_MAX_REMAINS",
                        type: "minute"
                    },
                    "QUANTITY",
                    "PACKING_UNIT_TYPE_ORDER_NAME",
                    "NETTO_WEIGHT",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "LDM",
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID: "[row].UNITS_IDS"
                },
                dataFields: ["ID_UNIT_CATEGORY", "STORE_DATE_MAX_JSON"],
                prepares: ["StoreMaxDateByPrevSea"],
                plugins: [
                    {
                        name: "InlineFilter",
                        params: {
                            columns: [
                                {
                                    name: "UNIT_TYPE_NAME",
                                    filterBy: {
                                        fields: {
                                            ID_UNIT_CATEGORY:
                                                "ID_UNIT_CATEGORY"
                                        }
                                    }
                                }
                            ]
                        }
                    },
                    {
                        name: "StoreMaxDateByPrevSea"
                    }
                ]
            }
        },
        plugins: [
            {
                name: "OperationUnitLinkInSub"
            },
            {
                name: "StockFilter",
                params: {
                    modules: ["Transline"]
                }

            }
        ]
    },
    operation_sub_doc_sea: { //Коносаменты
        type: "Grid",
        tableName: "OPERATION_SUB_DOC",
        dataFields: [
            "ARR_POINT_IDS"
        ],
        sysFilter: {
            type: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 3
            },
            valid: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_doc_parent_order_archive: {
                key: "IS_DOC_PARENT_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        sysFilterForCount: true,
        access: {
            create: false
        },
        excludeFields: [
            "REASON_BEING_LATE_NAME",
            "WAREHOUSE_DATE_UNLOADING",
            "ORDER_DATE",
            "UNIT_NUMBER_ORDER",
            "CARGO_CONDITION_NAME",
            "CARGO_INFORMING_NAME",
            "CONTAINER_STOCK_NAME"
        ]
    },
    operation_sub_doc_air: {
        type: "Grid",
        tableName: "OPERATION_SUB_DOC",
        sysFilter: {
            type: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 4
            },
            valid: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_doc_parent_order_archive: {
                key: "IS_DOC_PARENT_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        excludeFields: ["PAYMENT_TYPE_HBL_NAME","HBL_NUMBER"],
        noColumnRights: true,
        noToolbarRights: true
    },
    operation_sub_doc_repacking: {
        type: "Grid",
        tableName: "OPERATION_SUB_DOC",
        sysFilter: {
            type: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 5
            },
            valid: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_doc_parent_order_archive: {
                key: "IS_DOC_PARENT_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        noColumnRights: true,
        noToolbarRights: true
    },
    operation_sub_doc_customs: {
        type: "Grid",
        tableName: "OPERATION_SUB_DOC",
        sysFilter: {
            type: {
                key: "ID_DOC_PARENT_OPERATION_TYPE",
                type: "equal",
                value: 6
            },
            valid: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_doc_parent_order_archive: {
                key: "IS_DOC_PARENT_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        noColumnRights: true,
        noToolbarRights: true
    },
    logistas_unit: {
        icon: "cubes",
        type: "Grid",
        tableName: "LOGISTAS_UNIT",
        edit: {
            mode: "inline"
        },
        toolbar: {
            kit: "logistas_unit_kit"
        }
    },
    operation_rate_expense_type: {
        icon: "cubes",
        type: "Grid",
        tableName: "OPERATION_RATE_EXPENSE_TYPE"
    },
    operation_packing_unit_type: {
        icon: "cubes",
        type: "Grid",
        tableName: "OPERATION_PACKING_UNIT_TYPE"
    },
    invoice_incoming_money: {
        type: "Grid",
        tableName: "INVOICE_INCOMING_MONEY",
        langTableName: "INVOICE_INCOMING_MONEY",
        dataFields: [
            "ARCHIVED_ORDER"
        ],
        sysFilterForCount: true,
        excludeFields: [
            "INVOICE_1C_UNLOAD_TYPE_NAME",
            "INVOICE_PROGRESS_STATUS_NAME",
            "INVOICE_SUMM",
            "BALANCE",
            {
                key: "SUM_WITH_VAT_IN_ACTUAL_CURS",
                module: "EuroAsia"
            },
            "ICB_FACT_CODE",
            "ICB_VENDOR_CODE",
            "ICB_CUSTOMER_CODE",
            "PAYABLE_CSO",
            "HAS_CLOSED_DOCS",
            "IS_CLOSING_DOC_TRANSFER"
        ],
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_INVOICE_TYPE: 3,
                        // eslint-disable-next-line no-cyrillic-string/no-cyrillic-string
                        DOC_NUMBER: "Приход ДС"
                    }
                }
            },
            {
                name: "DisableInlineEditAllColumns",
                params: [
                    {
                        message: "archived_order_equals_1",
                        filter: {
                            isArchivedOrder: {
                                key: "ARCHIVED_ORDER",
                                type: "equal",
                                value: 1
                            }
                        },
                        notModule: ["EuroAsia"],
                        combine: [
                            {
                                excludeFields: [
                                    "PAYMENT_DATE",
                                    "INVOICE_1C_UNLOAD_TYPE_NAME",
                                    "HAS_CLOSED_DOCS",
                                    "IS_CLOSING_DOC_TRANSFER",
                                    "DATE_SEND_CLOSED_DOCS"
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                name: "FixInvoiceTitlePlugin"
            }
        ],
        toolbar: {
            kit: "invoices"
        }
    },
    invoice_outgoing_money: {
        type: "Grid",
        tableName: "INVOICE_OUTGOING_MONEY",
        langTableName: "INVOICE_OUTGOING_MONEY",
        dataFields: [
            "IS_MANAGER_BONUS_PERIOD_CLOSE",
            "ARCHIVED_ORDER"
        ],
        sysFilterForCount: true,
        excludeFields: [
            "INVOICE_1C_UNLOAD_TYPE_NAME",
            "INVOICE_PROGRESS_STATUS_NAME",
            "INVOICE_SUMM",
            "BALANCE",
            {
                key: "SUM_WITH_VAT_IN_ACTUAL_CURS",
                module: "EuroAsia"
            },
            "ICB_FACT_CODE",
            "ICB_VENDOR_CODE",
            "ICB_CUSTOMER_CODE",
            "PAYABLE_CSO",
            "HAS_CLOSED_DOCS",
            "IS_CLOSING_DOC_TRANSFER"
        ],
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_INVOICE_TYPE: 4,
                        // eslint-disable-next-line no-cyrillic-string/no-cyrillic-string
                        DOC_NUMBER: "Расход ДС"
                    }
                }
            },
            {
                name: "FixInvoiceTitlePlugin"
            },
            {
                name: "DisableInlineEditAllColumns",
                params: [
                    {
                        message: "is_manager_bonus_period_close_1",
                        filter: {
                            isPeriodClose: {
                                key: "IS_MANAGER_BONUS_PERIOD_CLOSE",
                                type: "equal",
                                value: 1
                            }
                        },
                        excludeFields: [
                            "PAYMENT_DATE",
                            "DATE_SEND_CLOSED_DOCS",
                            "INVOICE_1C_UNLOAD_TYPE_NAME"
                        ]
                    },
                    {
                        message: "archived_order_equals_1",
                        filter: {
                            isArchivedOrder: {
                                key: "ARCHIVED_ORDER",
                                type: "equal",
                                value: 1
                            }
                        },
                        notModule: ["EuroAsia"],
                        excludeFields: [
                            "PAYMENT_DATE",
                            "INVOICE_1C_UNLOAD_TYPE_NAME",
                            "HAS_CLOSED_DOCS",
                            "IS_CLOSING_DOC_TRANSFER",
                            "DATE_SEND_CLOSED_DOCS"
                        ]
                    }
                ]
            }
        ],
        toolbar: {
            kit: "invoices"
        }
    },
    group_operation: {
        icon: "warehouse",
        type: "CombinerOperation"
    },
    permission: {
        type: "Grid",
        tableName: "SYS_ACL_ROLE"
    },
    document_management_outgoing: {
        type: "Grid",
        tableName: "DOCUMENT_MANAGEMENT",
        sysFilterForCount: true,
        sysFilter: {
            incoming: {
                key: "ID_DOCUMENT_MANAGEMENT_TYPE",
                type: "equal",
                value: 1
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_DOCUMENT_MANAGEMENT_TYPE: 1
                    }
                }
            }
        ],
        fields: [
            "ID",
            "DOCUMENT_MANAGEMENT_TYPE_NAME",
            "DOCUMENT_MANAGEMENT_DOC_TYPE_NAME",
            "IS_DIRECT",
            "DESCRIPTION",
            "NOTE",
            "ENVELOPE_NUMBER",
            "COMPANY_FROM_NAME",
            "COMPANY_TO_NAME",
            "COMPANY_COURIER_NAME",
            "THEIR_COURIER_FULL_NAME",
            "OUR_COURIER_FULL_NAME",
            "USER_FROM_FULL_NAME",
            "USER_TO",
            "DT_CREATE",
            "DT_UPDATE",
            "LIST_USER_NAME_CREATE",
            "LIST_USER_NAME_UPDATE"
        ]
    },
    document_management_incoming: {
        type: "Grid",
        tableName: "DOCUMENT_MANAGEMENT",
        sysFilterForCount: true,
        sysFilter: {
            incoming: {
                key: "ID_DOCUMENT_MANAGEMENT_TYPE",
                type: "equal",
                value: 2
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_DOCUMENT_MANAGEMENT_TYPE: 2
                    }
                }
            }
        ],
        fields: [
            "ID",
            "DOCUMENT_MANAGEMENT_TYPE_NAME",
            "DOCUMENT_MANAGEMENT_DOC_TYPE_NAME",
            "IS_DIRECT",
            "DESCRIPTION",
            "NOTE",
            "ENVELOPE_NUMBER",
            "COMPANY_FROM_NAME",
            "COMPANY_TO_NAME",
            "COMPANY_COURIER_NAME",
            "THEIR_COURIER_FULL_NAME",
            "OUR_COURIER_FULL_NAME",
            "USER_FROM",
            "USER_TO_FULL_NAME",
            "DT_CREATE",
            "DT_UPDATE",
            "LIST_USER_NAME_CREATE",
            "LIST_USER_NAME_UPDATE"
        ]
    },
    document_management_doc_type: {
        type: "Grid",
        tableName: "DOCUMENT_MANAGEMENT_DOC_TYPE"
    },
    user_task_theme: {
        type: "Grid",
        tableName: "USER_TASK_THEME"
    },
    user_task_theme_to_bus_op: {
        type: "Grid",
        tableName: "USER_TASK_THEME_TO_BUS_OP"
    },
    fin_operation_group_unit: {
        type: "Grid",
        tableName: "FIN_OPERATION_GROUP_UNIT"
    },
    fin_operation: {
        type: "Grid",
        tableName: "FIN_OPERATION",
        access: {
            create: false
        },
        sysFilterForCount: true,
        sysFilter: {
            isBuy: {
                key: "ID_FIN_OPERATION_TYPE",
                type: "equal",
                value: 1
            },
            isMain: {
                key: "ID_FIN_OPERATION_MAIN_TYPE",
                type: "equal",
                value: 1
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_FIN_OPERATION_TYPE: 1,
                        ID_FIN_OPERATION_MAIN_TYPE: 1
                    }
                }
            }
        ]
    },
    combiner_remains: {
        type: "Grid",
        tableName: "OPERATION_UNIT",
        langTableName: "OPERATION_UNIT.combiner_remains",
        sysFilter: {
            hasntCombiner: {
                key: "COMBINER_OPERATIONS",
                type: "composite",
                onlyNulls: true
            },
            combinerOrderType: {
                key: "ID_ORDER_TYPE2",
                type: "in",
                value: [4, 2, 7, 8]
            },
            existsOrder: {
                key: "ORDER_DELETED",
                type: "equal",
                value: 0
            },
            notArchiveOrder: {
                key: "ORDER_ACTUAL_DATE_COMING",
                type: "composite",
                onlyNulls: true
            }
        },
        sysFilterForCount: true,
        tabsApi: "OPERATION_UNIT.combiner_remains",
        fields: [
            {
                key: "checked",
                title: "",
                isData: false,
                isVirtual: true,
                virtual: true,
                fixed: true,
                sort: false,
                filter: false,
                resize: false,
                width: 20,
                type: "checkbox",
                edit: false,
                form: false,
                icon: "checkbox",
                safeWarning: false,
                selection: false
            },
            "ID",
            "ORDER_SYS_SERIAL_NUMBER",
            "UNIT_NUMBER",
            "ORDER_FORWARD_TYPE_NAME",
            "NUMBER_BY_CLIENT",
            "ORDER_COMPANY_CLIENT_NAME",
            "LIST_NAME_WEIGHT_NAME",
            "ORDER_START_POINT_NAME",
            "ORDER_END_POINT_NAME",
            "ORDER_DATE_LOADING",
            "ORDER_DATE_DELIVERY",
            "ORDER_QUANTITY",
            "PACKING_UNIT_TYPE_ORDER_NAME",
            "QUANTITY_PALLET",
            "LIST_CLASS_DANGER_CODE",
            "TEMPERATURE_MODE",
            "UNIT_STATUS_TEXT",
            "UNIT_STATUS_DATE_START",
            "STATUS_POINT_START_NAME",
            "STATUS_POINT_END_NAME",
            "STATUS_POINT_CURRENT_NAME",
            "ORDER_NOTE",
            {
                key: "AUTO_UNIT_NUMBERS",
                type: "text"
            },
            "SEA_DATE_UNLOADING",
            "SEA_LEAVE_UNLOADING_DIFF",
            "ORDER_USER_OPERATIONS_FULL_NAME",
            "ORDER_LIST_DELIVERY_CONDITIONS_NAME",
            "ORDER_PAY_TYPE_NAME",
            "POINT_CONS_STOCK_NAME",
            "COUNTRY_START_NAME",
            "POINT_START_NAME",
            "FIRST_AIR_DOC_NUMBER",
            "GROUP_NUMBERS",
            "ORDER_NUMBER_BY_CLIENT",
            "ORDER_DATE",
            "COMPANY_CONSIGNEE_NAME",
            "ORDER_COMPANY_PARTNER_NAME"
        ],
        dataFields: ["ID_ORDER", "ID_ORDER_TYPE"],
        toolbar: {
            kit: [
                "create-combiner",
                "add",
                "edit",
                "delete",
                "unit-map",
                "styles",
                "columns",
                "filters",
                "reload",
                "export",
                "task",
                "chat",
                "changeLog",
                "trash",
                "reports",
                "rowsLength",
                "search"
            ]
        },
        plugins: [
            {
                name: "CombinerRemains"
            }
        ]
    },
    combiner_operations: {
        type: "Grid",
        tableName: "OPERATION_COMBINER",
        langTableName: "OPERATION.combiner",
        fields: [
            {
                key: "checked",
                title: "",
                isData: false,
                isVirtual: true,
                virtual: true,
                fixed: true,
                sort: false,
                filter: false,
                resize: false,
                width: 20,
                type: "checkbox",
                edit: false,
                form: false,
                icon: "checkbox",
                safeWarning: false,
                selection: false
            },
            "ID",
            "OPERATION_FORWARD_TYPE_NAME",
            "OPERATION_TYPE_NAME",
            "NOTE",
            "UNITS_NUMBERS",
            "STATUS_NAME",
            "UNITS_STATUSES",
            "UNITS_DISLOCATIONS",
            "COMPANY_CONSIGNOR_NAME",
            "COMPANY_CONSIGNEE_NAME",
            "UNITS_COUNT",
            "ARRIVAL_POINT_NAMES",
            "USER_LOGIST_FULL_NAME",
            "DEPARTMENT_LOGIST_NAME",
            "COUNTRY_START_NAME",
            "EXPECTED_DATE_START",
            "ACTUAL_DEPARTURE_DATE_START",
            "COUNTRY_END_NAME",
            "POINT_START_NAME",
            "POINT_END_NAME",
            "EXPECTED_DATE_END",
            "ACTUAL_DATE_END",
            "EXPECTED_START_OVER_MINUTES",
            "EXECUTE_TIME_MINUTE",
            "COST_BUY_OR_COEFF",
            "ACTUAL_COST_BUY",
            "COST_BUY_VAT",
            "COST_BUY_WITH_VAT",
            "COST_BUY_WITHOUT_VAT",
            "CURRENCY_COST_BUY_CHARCODE",
            "VAT_TYPE_BUY_NAME",
            "VAT_BUY_NAME",
            "COMPANY_EXECUTOR_NAME",
            "PACKING_UNIT_TYPE_NAME",
            "DATE_RATE_START",
            "DATE_RATE_END",
            "RATE_EXPENSE_TYPE_NAME",
            "COST_SALE_OR_COEFF",
            "ACTUAL_COST_SALE",
            "COST_SALE_VAT",
            "COST_SALE_WITH_VAT",
            "COST_SALE_WITHOUT_VAT",
            "VAT_SALE_NAME",
            "VAT_TYPE_SALE_NAME",
            "CURRENCY_COST_SALE_CHARCODE",
            "ORDER_SYS_SERIAL_NUMBER",
            "OPERATION_TYPE_NAME_WITH_RATE_TYPE_NAME",
            "ORDER_QUANTITY_PLACES",
            "ORDER_VOLUME",
            "ORDER_GROSS_WEIGHT",
            "ORDER_USER_OPERATIONS_FULL_NAME",
            "ORDER_LIST_DELIVERY_CONDITIONS_NAME",
            "CLIENT_NUMBERS",
            "COMPANY_CLIENT_NAMES",
            "REMAINING_UNITS_COUNT",
            "MAX_DATE_UNIT_LEAVE",
            "GROUP_NUMBER",
            "CONTAINER_NUMBER",
            "BOOKING_NUMBER",
            "AUTO_UNIT_NUMBER",
            "UNIT_NUMBERS_BY_CLIENT",
            "COMPANY_PARTNER_NAMES",
            "POINT_LAST_NAME",
            "EXPECTED_DATE_LAST",
            "ACTUAL_DATE_LAST"
        ],
        sysFilter: {
            isAllOrdersArchived: {
                key: "IS_ALL_ORDERS_ARCHIVED",
                type: "equal",
                value: 0
            }
        },
        sysFilterForCount: true,
        tabsApi: "OPERATION.combiner",
        dataFields: ["SEA_DATE_UNLOADING"],
        excludeFields: ["ORDER_USER_OPERATIONS_FULL_NAME"],
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                edit: {
                    mode: "inline"
                },
                behaviors: {
                    CellEditor: {
                        noCheckSafe: true
                    }
                },
                fields: [
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_NUMBER",
                    "ORDER_NUMBER_BY_CLIENT",
                    "ORDER_USER_OPERATIONS_FULL_NAME",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNEE_NAME",
                    "ORDER_LIST_NAME_WEIGHT_NAME",
                    "QUANTITY",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "SEA_DATE_UNIT_LEAVE",
                    {
                        key: "SEA_DATE_UNLOADING",
                        type: "date"
                    },
                    {
                        key: "SEA_LEAVE_UNLOADING_DIFF",
                        type: "date"
                    },
                    {
                        key: "UNIT_CATEGORY_NAME",
                        notModule: ["Intrans"]
                    },
                    {
                        key: "UNIT_TYPE_NAME",
                        notModule: ["Intrans"]
                    },
                    {
                        key: "ORDER_COMPANY_CONSIGNOR_NAME",
                        notModule: ["Intrans"]
                    },
                    {
                        key: "PACKING_UNIT_TYPE_ORDER_NAME",
                        notModule: ["Intrans"]
                    },
                    {
                        key: "NETTO_WEIGHT",
                        notModule: ["Intrans"]
                    },
                    {
                        key: "LDM",
                        notModule: ["Intrans"]
                    },
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },
                dataFields: ["ID_ORDER"],
                prepares: ["SeaDateUnitLeave"],
                plugins: [
                    {
                        name: "SeaOperationUnitLeave"
                    }
                ]
            },
            OPERATION_SUB_DOC: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "OPERATION_SUB_DOC_TYPE_NAME",
                    "DOC_NUMBER",
                    "DOC_DATE",
                    "VESSEL_NAME",
                    "ARRIVAL_POINT_NAMES",
                    "UNITS_COUNT"
                ],
                link: {
                    ID_DOC_PARENT_OPERATION: "[row].ID"
                }
            },
            OPERATION_ARRIVAL_POINT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                sorts: [
                    {
                        SORT: 1
                    }
                ],
                edit: {
                    mode: "inline"
                },
                fields: [
                    "POINT_ROLE_NAME",
                    "COUNTRY_NAME",
                    "POINT_NAME",
                    "EXPECTED_DATE",
                    "ACTUAL_DATE",
                    "ACTUAL_DEPARTURE_DATE"
                ],
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID_OPERATION: "[row].ID"
                }
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        IS_GROUP_COMBINER: 1
                    }
                }
            },
            {
                name: "OperationUnitLinkInSub"
            },
            {
                name: "OperationUnitTotals"
            },
            {
                name: "CombinerOperationCreateMenu"
            }
        ]
    },
    combiner_all_units_all: {
        type: "Grid",
        tableName: "OPERATION_UNIT",
        langTableName: "OPERATION_UNIT.combiner_remains",
        sysFilter: {
            combinerOrderType: {
                key: "ID_ORDER_TYPE2",
                type: "in",
                value: [4, 2, 7, 8]
            },
            existsOrder: {
                key: "ORDER_DELETED",
                type: "equal",
                value: 0
            }
        },
        sysFilterForCount: true,
        tabsApi: "OPERATION_UNIT.combiner_remains",
        fields: [
            "ID",
            "ORDER_SYS_SERIAL_NUMBER",
            "UNIT_NUMBER",
            "ORDER_FORWARD_TYPE_NAME",
            "NUMBER_BY_CLIENT",
            "ORDER_NUMBER_BY_CLIENT",
            "ORDER_COMPANY_CLIENT_NAME",
            "LIST_NAME_WEIGHT_NAME",
            "ORDER_START_POINT_NAME",
            "ORDER_END_POINT_NAME",
            "ORDER_DATE_LOADING",
            "ORDER_DATE_DELIVERY",
            "PACKING_UNIT_TYPE_ORDER_NAME",
            "QUANTITY_PALLET",
            "LIST_CLASS_DANGER_CODE",
            "TEMPERATURE_MODE",
            "UNIT_STATUS_TEXT",
            "UNIT_STATUS_DATE_START",
            "STATUS_POINT_START_NAME",
            "STATUS_POINT_END_NAME",
            "STATUS_POINT_CURRENT_NAME",
            "ORDER_NOTE",
            {
                key: "AUTO_UNIT_NUMBERS",
                type: "text"
            },
            "SEA_DATE_UNLOADING",
            "SEA_LEAVE_UNLOADING_DIFF",
            "ORDER_USER_OPERATIONS_FULL_NAME",
            "ORDER_LIST_DELIVERY_CONDITIONS_NAME",
            "ORDER_PAY_TYPE_NAME",
            "POINT_CONS_STOCK_NAME",
            "COUNTRY_START_NAME",
            "POINT_START_NAME",
            "FIRST_AIR_DOC_NUMBER",
            "GROUP_NUMBERS",
            "ORDER_DATE",
            "MIN_DATE_GTD_CLEAR_EXPECTED",
            "QUANTITY",
            "GROSS_WEIGHT",
            "COMPANY_CONSIGNEE_NAME",
            "VOLUME",
            "ORDER_COMPANY_PARTNER_NAME",
            "EXPORT_IS_ALLOWED_UNTIL",
            "SEA_DATE_UNIT_LEAVE"
        ],
        dataFields: ["ORDER_QUANTITY", "ID_ORDER"],
        plugins: [
            {
                name: "CombinerAllUnits"
            }
        ],
        clone: {
            function: "clone_combiner",
            showForm: {
                entity: "ORDER"
            }
        }
    },
    combiner_all_units_archive: {
        type: "Grid",
        tableName: "OPERATION_UNIT",
        langTableName: "OPERATION_UNIT.combiner_remains",
        tabsApi: "OPERATION_UNIT.combiner_remains",
        sysFilter: {
            combinerOrderType: {
                key: "ID_ORDER_TYPE2",
                type: "in",
                value: [4, 2, 7, 8]
            },
            existsOrder: {
                key: "ORDER_DELETED",
                type: "equal",
                value: 0
            },
            isArchived: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 1
            }
        },
        sysFilterForCount: true,
        fields: [
            "ID",
            "ORDER_SYS_SERIAL_NUMBER",
            "UNIT_NUMBER",
            "ORDER_FORWARD_TYPE_NAME",
            "NUMBER_BY_CLIENT",
            "ORDER_NUMBER_BY_CLIENT",
            "ORDER_COMPANY_CLIENT_NAME",
            "LIST_NAME_WEIGHT_NAME",
            "ORDER_START_POINT_NAME",
            "ORDER_END_POINT_NAME",
            "ORDER_DATE_LOADING",
            "ORDER_DATE_DELIVERY",
            "PACKING_UNIT_TYPE_ORDER_NAME",
            "QUANTITY_PALLET",
            "LIST_CLASS_DANGER_CODE",
            "TEMPERATURE_MODE",
            "UNIT_STATUS_TEXT",
            "UNIT_STATUS_DATE_START",
            "STATUS_POINT_START_NAME",
            "STATUS_POINT_END_NAME",
            "STATUS_POINT_CURRENT_NAME",
            "ORDER_NOTE",
            {
                key: "AUTO_UNIT_NUMBERS",
                type: "text"
            },
            "SEA_DATE_UNLOADING",
            "SEA_LEAVE_UNLOADING_DIFF",
            "ORDER_USER_OPERATIONS_FULL_NAME",
            "ORDER_LIST_DELIVERY_CONDITIONS_NAME",
            "ORDER_PAY_TYPE_NAME",
            "POINT_CONS_STOCK_NAME",
            "COUNTRY_START_NAME",
            "POINT_START_NAME",
            "FIRST_AIR_DOC_NUMBER",
            "GROUP_NUMBERS",
            "ORDER_DATE",
            "MIN_DATE_GTD_CLEAR_EXPECTED",
            "QUANTITY",
            "GROSS_WEIGHT",
            "VOLUME",
            "COMPANY_CONSIGNEE_NAME",
            "ORDER_COMPANY_PARTNER_NAME",
            "EXPORT_IS_ALLOWED_UNTIL",
            "SEA_DATE_UNIT_LEAVE"
        ],
        dataFields: ["ORDER_QUANTITY", "ID_ORDER", "IS_ARCHIVE"],
        plugins: [
            {
                name: "CombinerAllUnits"
            }
        ],
        clone: {
            function: "clone_combiner",
            showForm: {
                entity: "ORDER"
            }
        }
    },
    combiner_all_units_current: {
        type: "Grid",
        tableName: "OPERATION_UNIT",
        langTableName: "OPERATION_UNIT.combiner_remains",
        tabsApi: "OPERATION_UNIT.combiner_remains",
        sysFilter: {
            combinerOrderType: {
                key: "ID_ORDER_TYPE2",
                type: "in",
                value: [4, 2, 7, 8]
            },
            existsOrder: {
                key: "ORDER_DELETED",
                type: "equal",
                value: 0
            },
            isArchived: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        sysFilterForCount: true,
        fields: [
            "ID",
            "ORDER_SYS_SERIAL_NUMBER",
            "UNIT_NUMBER",
            "ORDER_FORWARD_TYPE_NAME",
            "NUMBER_BY_CLIENT",
            "ORDER_NUMBER_BY_CLIENT",
            "ORDER_COMPANY_CLIENT_NAME",
            "LIST_NAME_WEIGHT_NAME",
            "ORDER_START_POINT_NAME",
            "ORDER_END_POINT_NAME",
            "ORDER_DATE_LOADING",
            "ORDER_DATE_DELIVERY",
            "PACKING_UNIT_TYPE_ORDER_NAME",
            "QUANTITY_PALLET",
            "LIST_CLASS_DANGER_CODE",
            "TEMPERATURE_MODE",
            "UNIT_STATUS_TEXT",
            "UNIT_STATUS_DATE_START",
            "STATUS_POINT_START_NAME",
            "STATUS_POINT_END_NAME",
            "STATUS_POINT_CURRENT_NAME",
            "ORDER_NOTE",
            {
                key: "AUTO_UNIT_NUMBERS",
                type: "text"
            },
            "SEA_DATE_UNLOADING",
            "SEA_LEAVE_UNLOADING_DIFF",
            "ORDER_USER_OPERATIONS_FULL_NAME",
            "ORDER_LIST_DELIVERY_CONDITIONS_NAME",
            "ORDER_PAY_TYPE_NAME",
            "POINT_CONS_STOCK_NAME",
            "COUNTRY_START_NAME",
            "POINT_START_NAME",
            "FIRST_AIR_DOC_NUMBER",
            "GROUP_NUMBERS",
            "ORDER_DATE",
            "MIN_DATE_GTD_CLEAR_EXPECTED",
            "QUANTITY",
            "GROSS_WEIGHT",
            "VOLUME",
            "COMPANY_CONSIGNEE_NAME",
            "ORDER_COMPANY_PARTNER_NAME",
            "EXPORT_IS_ALLOWED_UNTIL",
            "SEA_DATE_UNIT_LEAVE"
        ],
        dataFields: ["ORDER_QUANTITY", "ID_ORDER", "IS_ARCHIVE"],
        plugins: [
            {
                name: "CombinerAllUnits"
            }
        ],
        clone: {
            function: "clone_combiner",
            showForm: {
                entity: "ORDER"
            }
        }
    },
    doc_operation_type: {
        type: "Grid",
        tableName: "DOC_OPERATION_TYPE"
    },
    operation_type: {
        type: "Grid",
        tableName: "OPERATION_TYPE",
        access: {
            create: false,
            remove: false
        }
    },
    part_number: {
        type: "Grid",
        tableName: "PART_NUMBER",
        plugins: [
            "DontRemovePartNumber",
            {
                name: "FormBy",
                params: {
                    module: "Baltkomplekt",
                    PrepareDeclarationForm: {
                        id: "ID",
                        table: "PART_NUMBER"
                    }
                }
            }
        ]
    },
    part_number_prepare_declaration: {
        type: "Grid",
        tableName: "PART_NUMBER",
        langTableName: "PART_NUMBER_PREPARE_DECLARATION",
        plugins: [
            {
                name: "FormBy",
                params: {
                    PrepareDeclarationForm: {
                        id: "ID",
                        table: "PART_NUMBER"
                    }
                }
            }
        ],
        toolbar: {
            kit: "baseWithImportWithPrepareDeclarations"
        },
        form2: "PrepareDeclarationForm"
    },
    part_number_position: {
        type: "Grid",
        tableName: "PART_NUMBER_POSITION",
        access: {
            create: false,
            remove: false
        },
        dataFields: ["ID_PART_NUMBER"],
        fields: [
            "ID",
            "ID_PART_NUMBER",
            "DT_CREATE",
            "DT_UPDATE",
            "LIST_USER_NAME_CREATE",
            "LIST_USER_NAME_UPDATE",
            "ORDER_REFERENCE",
            "ORDER_NUMBER",
            "ORDER_ID",
            "UNIT_REFERENCE",
            "ID_UNIT",
            "COMPANY_CLIENT_NAME",
            "COMPANY_PARTNER_NAME",
            "FEACC_CODE",
            "ADDITIONAL_CODE",
            "DESCRIPTION_RUS",
            "DESCRIPTION_ENG",
            "QUANTITY",
            "UNIT_PRICE",
            "TOTAL_GROSS_WEIGHT",
            "TOTAL_NET_WEIGHT",
            "PRICE",
            "GROSS_WEIGHT",
            "NET_WEIGHT",
            "PRICE2",
            "COUNT_PLL",
            "GROSS_WEIGHT_WITHOUT_PLL",
            "ANALYTIC_TAX_RATE",
            "ANALYTIC_TAX_RATE_ADD",
            "ANALYTIC_NDS_RATE",
            "ANALYTIC_TP_TAX_TYPE_NAME",
            "ANALYTIC_TP_TAX",
            "ANALYTIC_TP_NDS",
            "ANALYTIC_RISK",
            "ANALYTIC_ITS",
            "ANALYTIC_RBN",
            "ANALYTIC_DEI",
            "ANALYTIC_TYPE_PRICE_NAME",
            "ANALYTIC_PROV_ITS",
            "ANALYTIC_PROV_RBN",
            "ANALYTIC_PROV_DEI",
            "LOG_ERROR_TEXT",
            "TP_KG",
            "DESCRIPTION_DECL",
            "AREA_OF_USE",
            "NUMBER_FLOOR",
            "PACKING_UNIT_TYPE_NAME",
            "PACKING_UNIT_TYPE_PN_ADD_NAME",
            "NUMBER_FLOOR_ADD",
            "UNIT_NUMBER",
            "COUNTRY_ORIGIN_NAME",
            "PART_NUMBER",
            "TRADEMARK",
            "MANUFACTURER",
            "SERTIFICATION_DECLARANT",
            "SERTIFICATION_NUMBER",
            "SERTIFICATION_START",
            "SERTIFICATION_END",
            "LIST_CURRENCY_CHARCODE",
            "GROUP_NUMBERS",
            "ADDRESS_POINT_NAME",
            "UNIT_DIVISION_NAME",
            "CLEAR_GTD_NUMBERS"
        ],
        plugins: [
            {
                name: "FormBy",
                params: {
                    PartNumberForm: {
                        id: "ID_PART_NUMBER",
                        table: "PART_NUMBER"
                    }
                }
            }
        ]
    },
    crm_production: {
        type: "Grid",
        tableName: "PRODUCTION"
    },
    document_type: {
        type: "Grid",
        tableName: "LIST_TYPE_DOCUMENT"
    },
    owner_unit: {
        type: "Grid",
        tableName: "OWNER_UNIT",
        dataFields: [
            "SEA_LAST_SEA_END_POINT_ID_COUNTRY",
            "FULL_LAST_SEA_END_POINT_ID_COUNTRY"
        ],
        toolbar: {
            kit: [
                "add",
                "edit",
                "delete",
                "showOwnerUnitMap",
                "styles",
                "columns",
                "filters",
                "clone",
                "reload",
                "export",
                "task",
                "chat",
                "changeLog",
                "trash",
                "reports",
                "rowsLength",
                "search"
            ]
        },
        excludeFields: [
            {
                key: "ACTUAL_DATE_ARRIVAL_PORT_DEPARTURE",
                module: ["Logoper", "Voskhod"]
            },
            "STATUS_POINT_START_COUNTRY_NAME"
        ],
        plugins: [
            "MultipleOwnerUnitFormByAdd",
            {
                name: "InlineFilter",
                params: {
                    columns: [
                        {
                            name: "SEA_ARRIVAL_OPERATION_POINT_WAREHOUSE_NAME",
                            filterBy: {
                                fields: {
                                    ID_LIST_COUNTRY:
                                        "SEA_LAST_SEA_END_POINT_ID_COUNTRY"
                                },
                                noRowsByNull: true
                            }
                        },
                        {
                            name: "FULL_ARRIVAL_OPERATION_POINT_WAREHOUSE_NAME",
                            filterBy: {
                                fields: {
                                    ID_LIST_COUNTRY:
                                        "FULL_LAST_SEA_END_POINT_ID_COUNTRY"
                                },
                                noRowsByNull: true
                            }
                        }
                    ]
                }
            },
            "DisableInlineEditRailwayTransportSign"
        ]
    },
    own_rolling_stock_unit: {
        type: "Grid",
        tableName: "OWN_ROLLING_STOCK_UNIT",
        toolbar: {
            kit: [
                "add",
                "edit",
                "delete",
                "showOwnerUnitMap",
                "styles",
                "columns",
                "filters",
                "clone",
                "reload",
                "export",
                "task",
                "chat",
                "changeLog",
                "trash",
                "reports",
                "rowsLength",
                "search"
            ]
        },
        dataFields: [
            "DATE_TERM_TEMPORARY_IMPORTATION"
        ],
        prepares: ["EndDateCBBRedColor"]
    },
    own_rolling_stock_unit_current: {
        type: "Grid",
        tableName: "OWN_ROLLING_STOCK_UNIT",
        tabsApi: "OWN_ROLLING_STOCK_UNIT.current",
        sysFilter: {
            IS_CURRENT: {
                key: "ARCHIVE_DATE",
                type: "composite",
                onlyNulls: true
            }
        },
        dataFields: [
            "DATE_TERM_TEMPORARY_IMPORTATION"
        ],
        sysFilterForCount: true,
        prepares: ["EndDateCBBRedColor"]
    },
    own_rolling_stock_unit_all: {
        type: "Grid",
        tableName: "OWN_ROLLING_STOCK_UNIT",
        tabsApi: "OWN_ROLLING_STOCK_UNIT.all",
        dataFields: [
            "DATE_TERM_TEMPORARY_IMPORTATION",
            "RESERVE"
        ],
        prepares: ["EndDateCBBRedColor"]
    },
    own_rolling_stock_unit_archive: {
        type: "Grid",
        tableName: "OWN_ROLLING_STOCK_UNIT",
        tabsApi: "OWN_ROLLING_STOCK_UNIT.archive",
        sysFilter: {
            IS_ARCHIVE: {
                key: "ARCHIVE_DATE",
                type: "composite",
                withNulls: false
            }
        },
        dataFields: [
            "DATE_TERM_TEMPORARY_IMPORTATION",
            "RESERVE"
        ],
        sysFilterForCount: true,
        plugins: ["DisableInlineEditIsArchiveOwnRollingStockUnit"],
        prepares: ["EndDateCBBRedColor"]
    },
    weight_group: {
        type: "Grid",
        tableName: "WEIGHT_GROUP"
    },
    tp_els: {
        type: "Form2",
        form2: "TpElsChooseGtdsForm"
    },
    receivables_report: {
        type: "Form2",
        form2: "ReceivablesReportChooseForm"
    },
    operation_unit_division: {
        type: "Grid",
        tableName: "OPERATION_UNIT_DIVISION"
    },
    operation_cargo_status_ex_t1: {
        type: "Grid",
        tableName: "OPERATION_CARGO_STATUS_EX_T1"
    },
    list_feacc_gtd: {
        type: "Grid",
        tableName: "LIST_FEACC_GTD"
    },
    operation_rate_expense_include: {
        type: "Grid",
        tableName: "OPERATION_RATE_EXPENSE_INCLUDE"
    },
    invoice_outgoing_doc_number_mask: {
        type: "Grid",
        tableName: "COMPANY_DOC_NUMBER_MASK",
        sysFilter: {
            TABLE_NAME: {
                key: "TABLE_NAME",
                type: "equal",
                value: "INVOICE_OUTGOING"
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        TABLE_NAME: "INVOICE_OUTGOING"
                    }
                }
            }
        ]
    },
    train_number_mask: {
        type: "Grid",
        tableName: "COMPANY_DOC_NUMBER_MASK",
        sysFilter: {
            TABLE_NAME: {
                key: "TABLE_NAME",
                type: "equal",
                value: "TRAIN"
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        TABLE_NAME: "TRAIN"
                    }
                }
            }
        ]
    },
    class_access_docs_type: {
        type: "Grid",
        tableName: "CLASS_ACCESS_DOCS_TYPE"
    },
    class_access_docs_type_count_44: {
        type: "Grid",
        tableName: "CLASS_ACCESS_DOCS_TYPE_COUNT_44",
        fields: ["ID", "NAME", "NOTE", "CLASS_ACCESS_DOCS_TYPE_NAME"]
    },
    class_access_docs: {
        type: "Grid",
        tableName: "CLASS_ACCESS_DOCS"
    },
    fin_operation_commercial_offer: {
        type: "Grid",
        tableName: "FIN_OPERATION_COMMERCIAL_OFFER",
        access: {
            create: false,
            remove: false
        },
        sysFilterForCount: true,
        sysFilter: {
            isValid: {
                key: "IS_VALID",
                type: "equal",
                value: 1
            },
            notArchiveOrder: {
                key: "ORDER_ACTUAL_DATE_COMING",
                type: "composite",
                onlyNulls: true
            },
            notDeletedOrder: {
                key: "ORDER_DELETED",
                type: "equal",
                value: 0
            },
            isRequestOrder: {
                key: "ORDER_IS_REQUEST",
                type: "equal",
                value: 1
            },
            notDocsSchemeOrder: {
                key: "ORDER_IS_DOCS_SCHEME",
                type: "equal",
                value: 0
            },
            isTemplateOrCommOfferOrder: {
                key: "ORDER_IS_TEMPLATE_OR_COMM_OFFER",
                type: "equal",
                value: 1
            },
            is_not_payed: {
                key: "IS_BIG_INVOICE_DIFF_OR_NOT_EXISTS_INVOICES",
                type: "equal",
                value: 1
            }
        },
        prepares: ["ColorsInvoiceSumIfEqualFinSum"],
        dataFields: [
            "SUM_INVOICE_SUMM_WITH_VAT_IN_CURS",
            "SUM_WITH_VAT_IN_CURS"
        ],
        toolbar: {
            kit: "finOperationCommOffer"
        },
        excludeFields: [
            "INVOICE_ISSUE_DATE",
            "INVOICE_ISSUE_ACTUAL_DATE",
            "COMPANY_CONSIGNOR_NAME",
            "COMPANY_CONSIGNEE_NAME",
            "GTD_LIST_WAREHOUSE_NAMES",
            "GTD_PROCEDURES",
            "SUM_TOTAL_FEACC_NO",
            {
                key: "INVOICE_ISSUE_DATE",
                notModule: "Eastex"
            },
            {
                key: "INVOICE_ISSUE_ACTUAL_DATE",
                notModule: "Eastex"
            }
        ]
    },
    fin_operation_buy: {
        type: "Grid",
        tableName: "FIN_OPERATION",
        access: {
            create: false,
            remove: false
        },
        sysFilterForCount: true,
        sysFilter: {
            isBuy: {
                key: "ID_FIN_OPERATION_TYPE",
                type: "equal",
                value: 1
            },
            isValid: {
                key: "IS_VALID",
                type: "equal",
                value: 1
            },
            notArchiveOrder: {
                key: "ORDER_ACTUAL_DATE_COMING",
                type: "composite",
                onlyNulls: true
            },
            notDeletedOrder: {
                key: "ORDER_DELETED",
                type: "equal",
                value: 0
            },
            notRequestOrder: {
                key: "ORDER_IS_REQUEST",
                type: "equal",
                value: 0
            },
            is_not_payed: {
                key: "IS_BIG_INVOICE_DIFF_OR_NOT_EXISTS_INVOICES",
                type: "equal",
                value: 1
            }
        },
        prepares: ["ColorsInvoiceSumIfEqualFinSum"],
        dataFields: [
            "SUM_INVOICE_SUMM_WITH_VAT_IN_CURS",
            "SUM_WITH_VAT_IN_CURS"
        ],
        toolbar: {
            kit: "finOperJournal"
        },
        excludeFields: [
            "INVOICE_ISSUE_DATE",
            "INVOICE_ISSUE_ACTUAL_DATE",
            "COMPANY_CONSIGNOR_NAME",
            "COMPANY_CONSIGNEE_NAME",
            "GTD_LIST_WAREHOUSE_NAMES",
            "GTD_PROCEDURES",
            "SUM_TOTAL_FEACC_NO"
        ]
    },
    fin_operation_sale: {
        type: "Grid",
        tableName: "FIN_OPERATION",
        access: {
            create: false,
            remove: false
        },
        sysFilterForCount: true,
        sysFilter: {
            isSale: {
                key: "ID_FIN_OPERATION_TYPE",
                type: "equal",
                value: 2
            },
            isValid: {
                key: "IS_VALID",
                type: "equal",
                value: 1
            },
            notArchiveOrder: {
                key: "ORDER_ACTUAL_DATE_COMING",
                type: "composite",
                onlyNulls: true
            },
            notDeletedOrder: {
                key: "ORDER_DELETED",
                type: "equal",
                value: 0
            },
            notRequestOrder: {
                key: "ORDER_IS_REQUEST",
                type: "equal",
                value: 0
            },
            is_not_payed: {
                key: "IS_BIG_INVOICE_DIFF_OR_NOT_EXISTS_INVOICES",
                type: "equal",
                value: 1
            }
        },
        prepares: ["ColorsInvoiceSumIfEqualFinSum"],
        dataFields: [
            "SUM_INVOICE_SUMM_WITH_VAT_IN_CURS",
            "SUM_WITH_VAT_IN_CURS"
        ],
        toolbar: {
            kit: "finOperJournal"
        },
        excludeFields: [
            {
                key: "INVOICE_ISSUE_DATE",
                notModule: "Eastex"
            },
            {
                key: "INVOICE_ISSUE_ACTUAL_DATE",
                notModule: "Eastex"
            }
        ]
    },
    fin_operation_buy_eastex: {
        type: "Grid",
        tableName: "FIN_OPERATION",
        access: {
            create: false,
            remove: false
        },
        sysFilterForCount: true,
        sysFilter: {
            isBuy: {
                key: "ID_FIN_OPERATION_TYPE",
                type: "equal",
                value: 1
            },
            isValid: {
                key: "IS_VALID",
                type: "equal",
                value: 1
            },
            notArchiveOrder: {
                key: "ORDER_ACTUAL_DATE_COMING",
                type: "composite",
                onlyNulls: true
            },
            notDeletedOrder: {
                key: "ORDER_DELETED",
                type: "equal",
                value: 0
            },
            notRequestOrder: {
                key: "ORDER_IS_REQUEST",
                type: "equal",
                value: 0
            }
        },
        prepares: ["ColorsInvoiceSumIfEqualFinSum"],
        dataFields: [
            "SUM_INVOICE_SUMM_WITH_VAT_IN_CURS",
            "SUM_WITH_VAT_IN_CURS"
        ],
        toolbar: {
            kit: "finOperJournal"
        },
        excludeFields: [
            "INVOICE_ISSUE_DATE",
            "INVOICE_ISSUE_ACTUAL_DATE",
            "COMPANY_CONSIGNOR_NAME",
            "COMPANY_CONSIGNEE_NAME",
            "GTD_LIST_WAREHOUSE_NAMES",
            "GTD_PROCEDURES",
            "SUM_TOTAL_FEACC_NO"
        ]
    },
    fin_operation_sale_eastex: {
        type: "Grid",
        tableName: "FIN_OPERATION",
        access: {
            create: false,
            remove: false
        },
        sysFilterForCount: true,
        sysFilter: {
            isSale: {
                key: "ID_FIN_OPERATION_TYPE",
                type: "equal",
                value: 2
            },
            isValid: {
                key: "IS_VALID",
                type: "equal",
                value: 1
            },
            notArchiveOrder: {
                key: "ORDER_ACTUAL_DATE_COMING",
                type: "composite",
                onlyNulls: true
            },
            notDeletedOrder: {
                key: "ORDER_DELETED",
                type: "equal",
                value: 0
            },
            notRequestOrder: {
                key: "ORDER_IS_REQUEST",
                type: "equal",
                value: 0
            }
        },
        prepares: ["ColorsInvoiceSumIfEqualFinSum"],
        dataFields: [
            "SUM_INVOICE_SUMM_WITH_VAT_IN_CURS",
            "SUM_WITH_VAT_IN_CURS"
        ],
        toolbar: {
            kit: "finOperJournal"
        },
        excludeFields: [
            {
                key: "INVOICE_ISSUE_DATE",
                notModule: "Eastex"
            },
            {
                key: "INVOICE_ISSUE_ACTUAL_DATE",
                notModule: "Eastex"
            }
        ]
    },
    payments_gtd_link: {
        type: "Grid",
        tableName: "LIST_PAYMENTS_GTD_LINK"
    },
    order_doc_number_mask: {
        type: "Grid",
        tableName: "COMPANY_DOC_NUMBER_MASK",
        fields: [
            "ID",
            "LIST_USER_NAME_UPDATE",
            "LIST_USER_NAME_CREATE",
            "DT_UPDATE",
            "DT_CREATE",
            "COMPANY_NAME",
            "MASK",
            "DATE_START",
            "DATE_END",
            "IS_GLOBAL_SERIAL"
        ],
        sysFilter: {
            TABLE_NAME: {
                key: "TABLE_NAME",
                type: "equal",
                value: "ORDER"
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        TABLE_NAME: "ORDER"
                    }
                }
            }
        ]
    },
    company_crm_doc_number_mask: {
        type: "Grid",
        tableName: "COMPANY_DOC_NUMBER_MASK",
        fields: [
            "ID",
            "LIST_USER_NAME_UPDATE",
            "LIST_USER_NAME_CREATE",
            "DT_UPDATE",
            "DT_CREATE",
            "COMPANY_NAME",
            "MASK",
            "DATE_START",
            "DATE_END",
            "IS_GLOBAL_SERIAL"
        ],
        sysFilter: {
            TABLE_NAME: {
                key: "TABLE_NAME",
                type: "equal",
                value: "COMPANY_CRM"
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        TABLE_NAME: "COMPANY_CRM"
                    }
                }
            }
        ]
    },
    operation_repacking: {
        type: "Grid",
        tableName: "OPERATION_REPACKING",
        sysFilterForCount: true,
        sysFilter: {
            repacking: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 5
            },
            notGroup: {
                key: "ID_OPERATION_GROUP_TYPE",
                type: "equal",
                value: 2
            },
            notScheme: {
                key: "IS_SCHEME",
                type: "equal",
                value: "0"
            },
            notDoc: {
                key: "ID_DOC_PARENT_OPERATION",
                type: "composite",
                onlyNulls: true
            },
            order_or_is_grouper: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_order_archive: {
                key: "IS_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        access: {
            create: false
        },
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                edit: {
                    mode: "inline"
                },
                fields: [
                    "UNIT_NUMBER",
                    "UNLOAD_IN_PORT_DATE",
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_CATEGORY_NAME",
                    "UNIT_TYPE_NAME",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNOR_NAME",
                    "ORDER_COMPANY_CONSIGNEE_NAME",
                    "DATE_RELEASE_READY",
                    "DATE_RELEASE_TO",
                    "QUANTITY",
                    "PACKING_UNIT_TYPE_ORDER_NAME",
                    "NETTO_WEIGHT",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "LDM",
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID: "[row].UNITS_IDS"
                },
                dataFields: ["ID_UNIT_CATEGORY"],
                plugins: [
                    {
                        name: "InlineFilter",
                        params: {
                            columns: [
                                {
                                    name: "UNIT_TYPE_NAME",
                                    filterBy: {
                                        fields: {
                                            ID_UNIT_CATEGORY:
                                                "ID_UNIT_CATEGORY"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                ]
            },
            OPERATION_SUB_DOC: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "OPERATION_SUB_DOC_TYPE_NAME",
                    "DOC_NUMBER",
                    "DOC_DATE",
                    "ARRIVAL_POINT_NAMES",
                    "DATE_FORWARD_PRESENT",
                    "DATE_FORWARD_EXECUTE",
                    "UNITS_COUNT"
                ],
                link: {
                    ID_DOC_PARENT_OPERATION: "[row].ID"
                }
            },
            OPERATION_ARRIVAL_POINT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                sorts: [
                    {
                        SORT: 1
                    }
                ],
                edit: {
                    mode: "inline"
                },
                fields: [
                    "POINT_ROLE_NAME",
                    "COUNTRY_NAME",
                    "POINT_NAME",
                    "EXPECTED_DATE",
                    "ACTUAL_DATE",
                    "ACTUAL_DEPARTURE_DATE"
                ],
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID_OPERATION: "[row].ID"
                }
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_OPERATION_TYPE: 5
                    }
                }
            },
            {
                name: "OperationUnitLinkInSub"
            }
        ]
    },
    operation_documentation: {
        type: "Grid",
        tableName: "OPERATION_DOCUMENTATION",
        sysFilterForCount: true,
        sysFilter: {
            documentation: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 8
            },
            notGroup: {
                key: "ID_OPERATION_GROUP_TYPE",
                type: "equal",
                value: 2
            },
            notScheme: {
                key: "IS_SCHEME",
                type: "equal",
                value: "0"
            },
            notDoc: {
                key: "ID_DOC_PARENT_OPERATION",
                type: "composite",
                onlyNulls: true
            },
            order_or_is_grouper: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_order_archive: {
                key: "IS_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        access: {
            create: false
        },
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                edit: {
                    mode: "inline"
                },
                fields: [
                    "UNIT_NUMBER",
                    "UNLOAD_IN_PORT_DATE",
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_CATEGORY_NAME",
                    "UNIT_TYPE_NAME",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNOR_NAME",
                    "ORDER_COMPANY_CONSIGNEE_NAME",
                    "DATE_RELEASE_READY",
                    "DATE_RELEASE_TO",
                    "QUANTITY",
                    "PACKING_UNIT_TYPE_ORDER_NAME",
                    "NETTO_WEIGHT",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "LDM",
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID: "[row].UNITS_IDS"
                },
                dataFields: ["ID_UNIT_CATEGORY"],
                plugins: [
                    {
                        name: "InlineFilter",
                        params: {
                            columns: [
                                {
                                    name: "UNIT_TYPE_NAME",
                                    filterBy: {
                                        fields: {
                                            ID_UNIT_CATEGORY:
                                                "ID_UNIT_CATEGORY"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                ]
            },
            OPERATION_SUB_DOC: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "OPERATION_SUB_DOC_TYPE_NAME",
                    "DOC_NUMBER",
                    "DOC_DATE",
                    "ARRIVAL_POINT_NAMES",
                    "DATE_FORWARD_PRESENT",
                    "DATE_FORWARD_EXECUTE",
                    "UNITS_COUNT"
                ],
                link: {
                    ID_DOC_PARENT_OPERATION: "[row].ID"
                }
            },
            OPERATION_ARRIVAL_POINT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                sorts: [
                    {
                        SORT: 1
                    }
                ],
                edit: {
                    mode: "inline"
                },
                fields: [
                    "POINT_ROLE_NAME",
                    "COUNTRY_NAME",
                    "POINT_NAME",
                    "EXPECTED_DATE",
                    "ACTUAL_DATE",
                    "ACTUAL_DEPARTURE_DATE"
                ],
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID_OPERATION: "[row].ID"
                }
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_OPERATION_TYPE: 8
                    }
                }
            },
            {
                name: "OperationUnitLinkInSub"
            }
        ]
    },
    operation_other: {
        type: "Grid",
        tableName: "OPERATION_OTHER",
        sysFilterForCount: true,
        sysFilter: {
            other: {
                key: "ID_OPERATION_TYPE",
                type: "equal",
                value: 9
            },
            notGroup: {
                key: "ID_OPERATION_GROUP_TYPE",
                type: "equal",
                value: 2
            },
            notScheme: {
                key: "IS_SCHEME",
                type: "equal",
                value: "0"
            },
            notDoc: {
                key: "ID_DOC_PARENT_OPERATION",
                type: "composite",
                onlyNulls: true
            },
            order_or_is_grouper: {
                key: "ORDER_OR_IS_GROUPER",
                type: "equal",
                value: 1
            },
            is_order_archive: {
                key: "IS_ORDER_ARCHIVE",
                type: "equal",
                value: 0
            }
        },
        access: {
            create: false
        },
        sub: {
            OPERATION_UNIT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                edit: {
                    mode: "inline"
                },
                fields: [
                    "UNIT_NUMBER",
                    "UNLOAD_IN_PORT_DATE",
                    "ORDER_SYS_SERIAL_NUMBER",
                    "UNIT_CATEGORY_NAME",
                    "UNIT_TYPE_NAME",
                    "ORDER_COMPANY_CLIENT_NAME",
                    "ORDER_COMPANY_CONSIGNOR_NAME",
                    "ORDER_COMPANY_CONSIGNEE_NAME",
                    "DATE_RELEASE_READY",
                    "DATE_RELEASE_TO",
                    "QUANTITY",
                    "PACKING_UNIT_TYPE_ORDER_NAME",
                    "NETTO_WEIGHT",
                    "GROSS_WEIGHT",
                    "VOLUME",
                    "LDM",
                    "UNIT_STATUS_TEXT",
                    "UNIT_STATUS_DATE_START",
                    "STATUS_POINT_START_NAME",
                    "STATUS_POINT_END_NAME",
                    "STATUS_POINT_CURRENT_NAME"
                ],
                form2: "OperationUnitForm",
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID: "[row].UNITS_IDS"
                },
                dataFields: ["ID_UNIT_CATEGORY"],
                plugins: [
                    {
                        name: "InlineFilter",
                        params: {
                            columns: [
                                {
                                    name: "UNIT_TYPE_NAME",
                                    filterBy: {
                                        fields: {
                                            ID_UNIT_CATEGORY:
                                                "ID_UNIT_CATEGORY"
                                        }
                                    }
                                }
                            ]
                        }
                    }
                ]
            },
            OPERATION_SUB_DOC: {
                toolbar: false,
                bottom: false,
                mode: "light",
                fields: [
                    "OPERATION_SUB_DOC_TYPE_NAME",
                    "DOC_NUMBER",
                    "DOC_DATE",
                    "ARRIVAL_POINT_NAMES",
                    "DATE_FORWARD_PRESENT",
                    "DATE_FORWARD_EXECUTE",
                    "UNITS_COUNT"
                ],
                link: {
                    ID_DOC_PARENT_OPERATION: "[row].ID"
                }
            },
            OPERATION_ARRIVAL_POINT: {
                toolbar: false,
                bottom: false,
                mode: "light",
                sorts: [
                    {
                        SORT: 1
                    }
                ],
                edit: {
                    mode: "inline"
                },
                fields: [
                    "POINT_ROLE_NAME",
                    "COUNTRY_NAME",
                    "POINT_NAME",
                    "EXPECTED_DATE",
                    "ACTUAL_DATE",
                    "ACTUAL_DEPARTURE_DATE"
                ],
                access: {
                    create: false,
                    remove: false
                },
                link: {
                    ID_OPERATION: "[row].ID"
                }
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_OPERATION_TYPE: 9
                    }
                }
            },
            {
                name: "OperationUnitLinkInSub"
            }
        ]
    },
    business_process_template: {
        type: "Grid",
        tableName: "BUSINESS_PROCESS",
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        IS_TEMPLATE: 1
                    }
                }
            }
        ],
        sysFilter: {
            IS_TEMPLATE: {
                key: "IS_TEMPLATE",
                type: "equal",
                value: 1
            }
        }
    },
    payments_by_bank: {
        type: "Form2",
        form2: "PaymentsByBankChooseForm"
    },
    client_gtds_by_years: {
        type: "Form2",
        form2: "ClientGtdsByYearsChooseForm"
    },
    list_feacc_article: {
        type: "Grid",
        tableName: "LIST_FEACC_ARTICLE",
        access: {
            create: false,
            remove: false
        },
        dataFields: ["ID_LIST_FEACC_GTD", "ID_LIST_GTD"]
    },
    list_feacc_article_current: {
        type: "Grid",
        tableName: "LIST_FEACC_ARTICLE",
        access: {
            create: false,
            remove: false
        },
        dataFields: ["ID_LIST_FEACC_GTD", "ID_LIST_GTD"],
        behaviors: {
            Sorts: false
        },
        sorts: [
            {
                ID: -1
            }
        ],
        plugins: [
            {
                name: "FormBy",
                params: {
                    GTDForm: {
                        columns: ["ID_LIST_GTD", "GTD_NUMBER"],
                        id: "ID_LIST_GTD",
                        table: "LIST_ALL_GTD"
                    }
                }
            },
            {
                name: "FormBy",
                params: {
                    GTDFeaccForm: {
                        id: "ID_LIST_FEACC_GTD",
                        table: "LIST_FEACC_GTD"
                    }
                }
            }
        ],
        tabsApi: "LIST_FEACC_ARTICLE.current",
        sysFilter: {
            IS_CURRENT: {
                key: "ARCHIVING_DATE",
                type: "composite",
                onlyNulls: true
            }
        },
        sysFilterForCount: true
    },
    list_feacc_article_archive: {
        type: "Grid",
        tableName: "LIST_FEACC_ARTICLE",
        access: {
            create: false,
            remove: false
        },
        dataFields: ["ID_LIST_FEACC_GTD", "ID_LIST_GTD"],
        behaviors: {
            Sorts: false
        },
        sorts: [
            {
                ID: -1
            }
        ],
        plugins: [
            {
                name: "FormBy",
                params: {
                    GTDForm: {
                        columns: ["ID_LIST_GTD", "GTD_NUMBER"],
                        id: "ID_LIST_GTD",
                        table: "LIST_ALL_GTD"
                    }
                }
            },
            {
                name: "FormBy",
                params: {
                    GTDFeaccForm: {
                        id: "ID_LIST_FEACC_GTD",
                        table: "LIST_FEACC_GTD"
                    }
                }
            }
        ],
        tabsApi: "LIST_FEACC_ARTICLE.archive",
        sysFilter: {
            IS_ARCHIVE: {
                key: "ARCHIVING_DATE",
                type: "composite",
                withNulls: false
            }
        },
        sysFilterForCount: true
    },
    list_feacc_article_all: {
        type: "Grid",
        tableName: "LIST_FEACC_ARTICLE",
        access: {
            create: false,
            remove: false
        },
        dataFields: ["ID_LIST_FEACC_GTD", "ID_LIST_GTD"],
        behaviors: {
            Sorts: false
        },
        sorts: [
            {
                ID: -1
            }
        ],
        plugins: [
            {
                name: "FormBy",
                params: {
                    GTDForm: {
                        columns: ["ID_LIST_GTD", "GTD_NUMBER"],
                        id: "ID_LIST_GTD",
                        table: "LIST_ALL_GTD"
                    }
                }
            },
            {
                name: "FormBy",
                params: {
                    GTDFeaccForm: {
                        id: "ID_LIST_FEACC_GTD",
                        table: "LIST_FEACC_GTD"
                    }
                }
            }
        ],
        tabsApi: "LIST_FEACC_ARTICLE.all"
    },
    operation_rate_expense_category: {
        type: "Grid",
        tableName: "OPERATION_RATE_EXPENSE_CATEGORY"
    },
    business_process: {
        type: "Grid",
        tableName: "BUSINESS_PROCESS"
    },
    business_operation: {
        type: "Grid",
        tableName: "BUSINESS_OPERATION"
    },
    gtd_clients_by_years: {
        type: "Form2",
        form2: "GtdClientsByYearsChooseForm"
    },
    order_units_by_years: {
        type: "Form2",
        form2: "OrderUnitsByYearsChooseForm"
    },
    order_profit_by_operation_type_by_years: {
        type: "Form2",
        form2: "OrderProfitByOperationTypeYearsChooseForm"
    },
    settings: {
        type: "Form2",
        form2: "SettingsForm",
        table: "SETTINGS",
        // Magic id 1 Потому что там только одна строка!
        id: 1
    },
    credit_late_invoices: {
        type: "Form2",
        form2: "LateInvoicesChooseForm",
        single: "LateInvoicesChooseForm-credit",
        data: {
            ID_INVOICE_TYPE: 1
        },
        reportTable: "LIST_COMPANY"
    },
    debit_late_invoices: {
        type: "Form2",
        form2: "LateInvoicesChooseForm",
        single: "LateInvoicesChooseForm-debit",
        data: {
            ID_INVOICE_TYPE: 2
        },
        reportTable: "LIST_COMPANY"
    },
    client_payment_balance: {
        type: "Form2",
        form2: "ClientPaymentBalanceChooseForm"
    },
    operation_custom_status_type: {
        type: "Grid",
        tableName: "OPERATION_CUSTOM_STATUS_TYPE",
        form2: "NameNoteForm"
    },
    operation_custom_status: {
        type: "Grid",
        tableName: "OPERATION_CUSTOM_STATUS",
        form2: "OperationCustomStatusForm"
    },
    request_gtd: {
        type: "Grid",
        tableName: "REQUEST_GTD"
    },
    request_status_crm: {
        type: "Grid",
        tableName: "CRM_REQUEST_STATUS"
    },
    company_crm_event_type: {
        type: "Grid",
        tableName: "COMPANY_CRM_EVENT_TYPE"
    },
    list_contact_persons_email_broadcast_config: {
        type: "Grid",
        tableName: "LIST_CONTACT_PERSONS_EMAIL_BROADCAST_CONFIG"
    },
    nomenclature_to_print: {
        type: "Grid",
        tableName: "NOMENCLATURE_TO_PRINT"
    },
    template_invoice_post: {
        type: "Grid",
        tableName: "TEMPLATE_INVOICE_POST"
    },
    template_invoice: {
        type: "Grid",
        tableName: "TEMPLATE_INVOICE"
    },
    order_notifications: {
        type: "Grid",
        tableName: "ORDER_NOTIFICATIONS",
        access: {
            create: false,
            edit: false,
            remove: false
        },
        toolbar: {
            kit: "order_notifications_kit"
        }
    },
    list_gtd_notifications: {
        type: "Grid",
        tableName: "LIST_GTD_NOTIFICATIONS",
        access: {
            create: false,
            edit: false,
            remove: false
        },
        toolbar: {
            kit: "list_gtd_notifications_kit"
        },
        form2: "GtdNotificationForm"
    },
    document_status: {
        type: "Grid",
        tableName: "DOCUMENT_STATUS"
    },
    auto_rates: {
        type: "Grid",
        tableName: "AUTO_RATES"
    },
    sea_port_expenses: {
        type: "Grid",
        tableName: "SEA_PORT_EXPENSES"
    },
    storage_rates: {
        type: "Grid",
        tableName: "STORAGE_RATES",
        plugins: [
            "ValidateNumberOfDays",
            "StorageRatesCreate",
            {
                name: "FormBy",
                params: {
                    CompanyStorageRatesForm: {
                        id: "ID_COMPANY_STORAGE_RATES",
                        table: "COMPANY_STORAGE_RATES"
                    }
                }
            }
        ],
        dataFields: ["ID_COMPANY_STORAGE_RATES"]
    },
    gtd_result_returning_otp_status: {
        type: "Grid",
        tableName: "GTD_RESULT_RETURNING_OTP_STATUS"
    },
    gtd_additional_check_status: {
        type: "Grid",
        tableName: "GTD_ADDITIONAL_CHECK_STATUS"
    },
    manufacturer: {
        type: "Grid",
        tableName: "MANUFACTURER"
    },
    contracts_fea_addition_specifications: {
        type: "Grid",
        tableName: "CONTRACTS_FEA_ADDITION_SPECIFICATIONS"
    },
    list_reusable_containers: {
        type: "Grid",
        tableName: "LIST_REUSABLE_CONTAINERS"
    },
    list_reusable_containers_position: {
        type: "Grid",
        tableName: "LIST_REUSABLE_CONTAINERS_POSITION"
    },
    list_reusable: {
        type: "Grid",
        tableName: "LIST_REUSABLE"
    },
    balance_payment_accounts: {
        type: "Form2",
        form2: "BalancePaymentAccountsForm"
    },
    order_profit_by_general: {
        type: "Form2",
        form2: "OrderProfitByGeneralChooseForm"
    },
    person_to_notify: {
        type: "Grid",
        tableName: "PERSON_TO_NOTIFY"
    },
    supermarket_type: {
        type: "Grid",
        tableName: "SUPERMARKET_TYPE"
    },
    train_current: {
        type: "Grid",
        icon: "book",
        tableName: "TRAIN",
        tabsApi: "TRAIN.current",
        sysFilter: {
            IS_CURRENT: {
                key: "IS_CURRENT",
                type: "equal",
                value: 1
            }
        },
        sysFilterForCount: true
    },
    train_archive: {
        type: "Grid",
        icon: "book",
        tableName: "TRAIN",
        tabsApi: "TRAIN.archive",
        sysFilter: {
            IS_ARCHIVE: {
                key: "IS_CURRENT",
                type: "equal",
                value: 0
            }
        },
        sysFilterForCount: true
    },
    train_all: {
        type: "Grid",
        icon: "book",
        tableName: "TRAIN",
        sysFilterForCount: true
    },
    prepayment_report: {
        type: "Form2",
        form2: "PrepaymentReportChooseForm"
    },
    list_company_groups: {
        type: "Grid",
        tableName: "LIST_COMPANY_GROUPS"
    },
    effex_events_unit: {
        type: "Grid",
        tableName: "EFFEX_EVENTS_UNIT",
        edit: {
            mode: "inline"
        }
    },
    rolis_subscription: {
        type: "Grid",
        tableName: "ROLIS_SUBSCRIPTION",
        edit: {
            mode: "inline"
        }
    },
    payment_orders_expence_type: {
        type: "Grid",
        tableName: "PAYMENT_ORDERS_EXPENCE_TYPE"
    },
    payment_orders_group_expence_type: {
        type: "Grid",
        tableName: "PAYMENT_ORDERS_GROUP_EXPENCE_TYPE"
    },
    payment_orders_subgroup_expence_type: {
        type: "Grid",
        tableName: "PAYMENT_ORDERS_SUBGROUP_EXPENCE_TYPE"
    },
    gtd_units_report: {
        type: "Form2",
        form2: "ConsigneeGtdUnitsReportForm"
    },
    docs_send_method: {
        type: "Grid",
        tableName: "DOCS_SEND_METHOD"
    },
    payment_orders_incoming_doc_number_mask: {
        type: "Grid",
        tableName: "COMPANY_DOC_NUMBER_MASK",
        sysFilter: {
            TABLE_NAME: {
                key: "TABLE_NAME",
                type: "equal",
                value: "PAYMENT_ORDERS_INCOMING"
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        TABLE_NAME: "PAYMENT_ORDERS_INCOMING"
                    }
                }
            }
        ]
    },
    payment_orders_outgoing_doc_number_mask: {
        type: "Grid",
        tableName: "COMPANY_DOC_NUMBER_MASK",
        sysFilter: {
            TABLE_NAME: {
                key: "TABLE_NAME",
                type: "equal",
                value: "PAYMENT_ORDERS_OUTGOING"
            }
        },
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        TABLE_NAME: "PAYMENT_ORDERS_OUTGOING"
                    }
                }
            }
        ]
    },
    profit_report: {
        type: "Form2",
        form2: "ProfitReportConfigForm"
    },
    late_invoices_without_unaccounted_report: {
        type: "Form2",
        form2: "LateInvoicesWithoutUnaccountedChooseForm"
    },
    batch_fin_operation_buy: {
        type: "Grid",
        tableName: "BATCH_FIN_OPERATION",
        dataFields: ["INVOICES_IDS"],
        plugins: [
            {
                name: "DefRow",
                params: {
                    row: {
                        ID_FIN_OPERATION_TYPE: "1"
                    }
                }
            },
            {
                name: "DisableDeleteBatchFin"
            },
            {
                name: "DisableInlineEditorIfExistInvoice"
            }
        ]
    },
    settings_finance: {
        type: "Form2",
        form2: "FinanceSettingsForm",
        table: "FIN_SETTINGS",
        id: 1
    },
    list_company_category: {
        type: "Grid",
        tableName: "LIST_COMPANY_CATEGORY"
    },
    list_company_category_group: {
        type: "Grid",
        tableName: "LIST_COMPANY_CATEGORY_GROUP"
    },
    counterparty_balance_report: {
        type: "Form2",
        form2: "CounterpartyBalanceReportForm",
        reportTable: "LIST_COMPANY"
    },
    industry: {
        type: "Grid",
        form2: "IndustryForm",
        tableName: "INDUSTRY"
    },
    risk_class: {
        type: "Grid",
        form2: "RiskClassForm",
        tableName: "RISK_CLASS"
    },
    cost_price_report: {
        type: "Form2",
        form2: "CostPriceReportForm"
    },
    article_report: {
        type: "Form2",
        form2: "ArticleReportForm"
    },
    product: {
        type: "Grid",
        tableName: "PRODUCT"
    },
    move_type: {
        type: "Grid",
        tableName: "MOVE_TYPE"
    },
    biz_scope: {
        type: "Grid",
        tableName: "BIZ_SCOPE"
    },
    template_notification_mailing: {
        type: "Grid",
        tableName: "TEMPLATE_NOTIFICATION_MAILING",
        form2: "TemplateNotificationMailingForm"
    },
    template_notification_mailing_doc: {
        type: "Grid",
        tableName: "TEMPLATE_NOTIFICATION_MAILING_DOC",
        form2: "TemplateNotificationMailingDocForm"
    },
    dynamic_journals: {
        type: "Grid",
        tableName: "DYNAMIC_JOURNALS",
        toolbar: {
            kit: "configDynamicJournals"
        }
    },
    report_settings: {
        type: "Grid",
        tableName: "REPORT_SETTINGS",
        sysFilter: {
            ACTIVE: {
                key: "IS_ACTIVE",
                type: "equal",
                value: "1"
            }
        },
        access: {
            create: false,
            remove: false
        }
    },
    logos_lang_translation: {
        type: "Form2",
        form2: "LangTranslationForm"
    },
    icb_office: {
        type: "Grid",
        tableName: "ICB_OFFICE"
    },
    payable_cso: {
        type: "Grid",
        tableName: "PAYABLE_CSO"
    },
    doc_fin_operation_buy: {
        type: "Grid",
        tableName: "FIN_OPERATION_ORDER_DOC_LINK",
        access: {
            create: false,
            remove: false
        },
        sysFilterForCount: true,
        sysFilter: {
            isBuy: {
                key: "ID_FIN_OPERATION_TYPE",
                type: "equal",
                value: 1
            },
            isValid: {
                key: "IS_VALID",
                type: "equal",
                value: 1
            },
            notArchiveOrder: {
                key: "ORDER_ACTUAL_DATE_COMING",
                type: "composite",
                onlyNulls: true
            },
            notDeletedOrder: {
                key: "ORDER_DELETED",
                type: "equal",
                value: 0
            },
            notRequestOrder: {
                key: "ORDER_IS_REQUEST",
                type: "equal",
                value: 0
            },
            is_not_payed: {
                key: "IS_BIG_INVOICE_DIFF_OR_NOT_EXISTS_INVOICES",
                type: "equal",
                value: 1
            }
        },
        prepares: ["ColorsInvoiceSumIfEqualFinSum"],
        dataFields: [
            "SUM_INVOICE_SUMM_WITH_VAT_IN_CURS",
            "SUM_WITH_VAT_IN_CURS",
            "ID_FIN_OPERATION"
        ],
        toolbar: {
            kit: "finOperUnitAndOrderDocLinkJournal"
        },
        plugins: [
            {
                name: "FormBy",
                params: {
                    FinOperationForm: {
                        id: "ID_FIN_OPERATION",
                        table: "FIN_OPERATION",
                        activeTab: "link_docs"
                    }
                }
            }
        ]
    },
    doc_fin_operation_sale: {
        type: "Grid",
        tableName: "FIN_OPERATION_ORDER_DOC_LINK",
        access: {
            create: false,
            remove: false
        },
        sysFilterForCount: true,
        sysFilter: {
            isSale: {
                key: "ID_FIN_OPERATION_TYPE",
                type: "equal",
                value: 2
            },
            isValid: {
                key: "IS_VALID",
                type: "equal",
                value: 1
            },
            notArchiveOrder: {
                key: "ORDER_ACTUAL_DATE_COMING",
                type: "composite",
                onlyNulls: true
            },
            notDeletedOrder: {
                key: "ORDER_DELETED",
                type: "equal",
                value: 0
            },
            notRequestOrder: {
                key: "ORDER_IS_REQUEST",
                type: "equal",
                value: 0
            },
            is_not_payed: {
                key: "IS_BIG_INVOICE_DIFF_OR_NOT_EXISTS_INVOICES",
                type: "equal",
                value: 1
            }
        },
        prepares: ["ColorsInvoiceSumIfEqualFinSum"],
        dataFields: [
            "SUM_INVOICE_SUMM_WITH_VAT_IN_CURS",
            "SUM_WITH_VAT_IN_CURS",
            "ID_FIN_OPERATION"
        ],
        toolbar: {
            kit: "finOperUnitAndOrderDocLinkJournal"
        },
        plugins: [
            {
                name: "FormBy",
                params: {
                    FinOperationForm: {
                        id: "ID_FIN_OPERATION",
                        table: "FIN_OPERATION",
                        activeTab: "link_docs"
                    }
                }
            }
        ]
    },
    manager_bonus: {
        type: "Grid",
        tableName: "MANAGER_BONUS"
    },
    alta_cbx_data_all: {
        type: "Grid",
        tableName: "ALTA_CBX_DATA",
        tabsApi: "ALTA_CBX_DATA.alta_all"
    },
    alta_cbx_data_current: {
        type: "Grid",
        tableName: "ALTA_CBX_DATA",
        tabsApi: "ALTA_CBX_DATA.alta_current",
        sysFilter: {
            IS_ARCHIVE: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 0
            }
        }
    },
    alta_cbx_data_archive: {
        type: "Grid",
        tableName: "ALTA_CBX_DATA",
        tabsApi: "ALTA_CBX_DATA.alta_archive",
        sysFilter: {
            IS_ARCHIVE: {
                key: "IS_ARCHIVE",
                type: "equal",
                value: 1
            }
        }
    },
    courier: {
        type: "Grid",
        tableName: "COURIER"
    },
    financial_result_report: {
        type: "Form2",
        form2: "FinancialResultReportForm"
    },
    export_units_report_choose: {
        type: "Form2",
        form2: "ExportUnitsReportChooseForm"
    },
    contracts_fea_addition: {
        type: "Grid",
        tableName: "CONTRACTS_FEA_ADDITION",
        noColumnRights: true,
        noToolbarRights: true
    },
    cfo: {
        type: "Grid",
        tableName: "CFO"
    },
    brunch: {
        type: "Grid",
        tableName: "BRUNCH"
    },
    sample_collection: {
        type: "Grid",
        tableName: "SAMPLE_COLLECTION"
    },
    list_ownership_type: {
        type: "Grid",
        tableName: "LIST_OWNERSHIP_TYPE"
    },
    purchasing_document_report: {
        type: "Form2",
        form2: "PurchasingDocumentForm"
    },
    template_payment_schedule: {
        type: "Grid",
        tableName: "TEMPLATE_PAYMENT_SCHEDULE",
        form2: "TemplatePaymentScheduleForm"
    },
    service_combination: {
        type: "Grid",
        tableName: "SERVICE_COMBINATION"
    },
    ghq_activity: {
        type: "Grid",
        tableName: "GHQ_ACTIVITY"
    },
    payment_schedule: {
        type: "Grid",
        tableName: "PAYMENT_SCHEDULE",
        form2: "PaymentScheduleForm"
    },
    criteria_delay: {
        type: "Grid",
        tableName: "CRITERIA_DELAY"
    },
    consol_type: {
        type: "Grid",
        tableName: "CONSOL_TYPE"
    },
    deviation_reason: {
        type: "Grid",
        tableName: "DEVIATION_REASON"
    },
    branch_yunas: {
        type: "Grid",
        tableName: "BRANCH_YUNAS"
    },
    counting_of_loading_units: {
        type: "Form2",
        form2: "CargoCounterForm"
    },
    data_changes_log_yunas: {
        type: "Grid",
        eid: "changeLogYunas",
        tableName: "DATA_CHANGES_LOG_YUNAS",
        leftColumn: false,
        access: {
            create: false,
            edit: false,
            remove: false
        },
        toolbar: {
            kit: [
                "styles",
                "columns",
                "filters",
                "reload",
                "export",
                "chat",
                "rowsLength",
                "search"
            ]
        },
        fields: [
            "SHIPMENT",
            "TABLE_NAME",
            "TABLE_ID",
            "CHANGE_DATE",
            "TRANSLATED_FIELD_NAME",
            "OLD_VALUE",
            "NEW_VALUE",
            "FIELD_YUNAS",
            "NEW_VALUE_YUNAS",
            "STATE",
            "ADDITIONAL_INFO"
        ]
    },
    rejected_by: {
        type: "Grid",
        tableName: "REJECTED_BY"
    },
    company_category_type: {
        type: "Grid",
        tableName: "COMPANY_CATEGORY_TYPE"
    },
    wht: {
        type: "Grid",
        tableName: "WHT"
    },
    company_subdivision: {
        type: "Grid",
        tableName: "COMPANY_SUBDIVISION"
    },
    forwarding_service_report: {
        type: "Form2",
        form2: "ForwardingServiceReportForm"
    }
};
